// this file was prevaled
// This file needs to be a JavaScript file using CommonJS to work with preval
// this file was prevaled
// we're using preval because we're going to be importing our styles as a module
// Cache bust: Mar 30 2023 9:14:35 GMT-0600 (This file is cached by the system's deployment tooling, so you'll need update this timestamp to rebuild this file)
module.exports = {
  "theme": {
    "animation": {
      "easeOutCubic": "cubic-bezier(0.33, 1, 0.68, 1)"
    },
    "borderWidths": [0, "1px"],
    "breakpoints": ["544px", "768px", "1012px", "1280px"],
    "fonts": {
      "normal": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\"",
      "mono": "SFMono-Regular, Consolas, \"Liberation Mono\", Menlo, Courier, monospace"
    },
    "fontSizes": ["10px", "11px", "14px", "16px", "20px", "24px", "28px", "36px", "47px", "62px", "84px"],
    "fontWeights": {
      "light": 300,
      "normal": 400,
      "semibold": 500,
      "bold": 600
    },
    "lineHeights": {
      "condensedUltra": 1,
      "condensed": 1.1428571429,
      "default": 1.42857142857143,
      "relaxed": 1.71429
    },
    "radii": ["0", "3px", "4px", "6px", "100px"],
    "sizes": {
      "small": "544px",
      "medium": "768px",
      "large": "1012px",
      "xlarge": "1280px"
    },
    "space": ["0", "4px", "8px", "16px", "24px", "32px", "40px", "48px", "64px", "80px", "96px", "112px", "128px"],
    "colorSchemes": {
      "light": {
        "colors": {
          "background": {
            "neutral": {
              "default": "#091E420F",
              "hovered": "#091e4224",
              "pressed": "#091e424f",
              "subtle": {
                "default": "#ffffff00",
                "hovered": "#091E420F",
                "pressed": "#091e4224"
              },
              "bold": {
                "default": "#44546F",
                "hovered": "#2C3E5D",
                "pressed": "#172B4D"
              }
            },
            "accent": {
              "blue": {
                "subtlest": "#E9F2FF",
                "subtler": "#CCE0FF",
                "subtle": "#85B8FF",
                "bolder": "#0C66E4"
              },
              "red": {
                "subtlest": "#FFEDEB",
                "subtler": "#FFD2CC",
                "subtle": "#F87462",
                "bolder": "#AE2A19"
              },
              "orange": {
                "subtlest": "#FFF4E5",
                "subtler": "#FFE2BD",
                "subtle": "#FAA53D",
                "bolder": "#B65C02"
              },
              "yellow": {
                "subtlest": "#FFF7D6",
                "subtler": "#F8E6A0",
                "subtle": "#F5CD47",
                "bolder": "#946F00"
              },
              "green": {
                "subtlest": "#DFFCF0",
                "subtler": "#BAF3DB",
                "subtle": "#2ABB7F",
                "bolder": "#1F845A"
              },
              "teal": {
                "subtlest": "#E3FAFC",
                "subtler": "#C1F0F5",
                "subtle": "#37B4C3",
                "bolder": "#1D7F8C"
              },
              "purple": {
                "subtlest": "#F3F0FF",
                "subtler": "#DFD8FD",
                "subtle": "#8F7EE7",
                "bolder": "#6E5DC6"
              },
              "magenta": {
                "subtlest": "#FFECF8",
                "subtler": "#FDD0EC",
                "subtle": "#DA62AC",
                "bolder": "#AE4787"
              },
              "gray": {
                "subtlest": "#FFFFFF",
                "subtler": "#F7F8F9",
                "subtle": "#B3B9C4",
                "bolder": "#758195"
              }
            },
            "disabled": "#091E420F",
            "inverse": {
              "subtle": {
                "default": "rgba(255,255,255,0.16)",
                "hovered": "rgba(255,255,255,0.24)",
                "pressed": "rgba(255,255,255,0.32)"
              }
            },
            "input": {
              "default": "#FFFFFF",
              "hovered": "#F7F8F9",
              "pressed": "#FFFFFF"
            },
            "brand": {
              "bold": {
                "default": "#0C66E4",
                "hovered": "#0055CC",
                "pressed": "#09326C"
              },
              "hovered": "#0055CC",
              "pressed": "#09326C"
            },
            "selected": {
              "default": "#E9F2FF",
              "hovered": "#CCE0FF",
              "pressed": "#85B8FF",
              "bold": {
                "default": "#0C66E4",
                "hovered": "#0055CC",
                "pressed": "#09326C"
              }
            },
            "danger": {
              "default": "#FFEDEB",
              "hovered": "#FFD2CC",
              "pressed": "#FF9C8F",
              "bold": {
                "default": "#CA3521",
                "hovered": "#AE2A19",
                "pressed": "#601E16"
              }
            },
            "warning": {
              "default": "#FFF7D6",
              "hovered": "#F8E6A0",
              "pressed": "#F5CD47",
              "bold": {
                "default": "#E2B203",
                "hovered": "#CF9F02",
                "pressed": "#B38600"
              }
            },
            "success": {
              "default": "#DFFCF0",
              "hovered": "#BAF3DB",
              "pressed": "#7EE2B8",
              "bold": {
                "default": "#1F845A",
                "hovered": "#216E4E",
                "pressed": "#164B35"
              }
            },
            "discovery": {
              "default": "#F3F0FF",
              "hovered": "#DFD8FD",
              "pressed": "#B8ACF6",
              "bold": {
                "default": "#6E5DC6",
                "hovered": "#5E4DB2",
                "pressed": "#352C63"
              }
            },
            "information": {
              "default": "#E9F2FF",
              "hovered": "#CCE0FF",
              "pressed": "#85B8FF",
              "bold": {
                "default": "#0C66E4",
                "hovered": "#0055CC",
                "pressed": "#09326C"
              }
            }
          },
          "blanket": {
            "default": "rgba(9,30,66,0.49)",
            "selected": "rgba(56,139,255,0.08)",
            "danger": "rgba(239,92,72,0.08)"
          },
          "skeleton": {
            "default": "#091E420F",
            "subtle": "#091E4208"
          },
          "interaction": {
            "hovered": "rgba(255,255,255,0.2)",
            "pressed": "rgba(255,255,255,0.36)",
            "inverse": {
              "hovered": "rgba(9,10,11,0.16)",
              "pressed": "rgba(9,10,11,0.32)"
            }
          },
          "link": {
            "default": "#0C66E4",
            "pressed": "#0055CC"
          },
          "elevation": {
            "surface": {
              "default": "#FFFFFF",
              "sunken": "#F7F8F9",
              "raised": "#FFFFFF",
              "overlay": "#FFFFFF"
            }
          },
          "text": {
            "default": "#172B4D",
            "subtle": "#44546F",
            "subtlest": "#626F86",
            "disabled": "#8993A5",
            "inverse": "#FFFFFF",
            "brand": "#0C66E4",
            "selected": "#0C66E4",
            "danger": "#AE2A19",
            "warning": {
              "default": "#974F0C",
              "inverse": "#172B4D"
            },
            "success": "#216E4E",
            "discovery": "#5E4DB2",
            "information": "#1D7AFC",
            "accent": {
              "blue": {
                "default": "#0055CC",
                "bolder": "#09326C"
              },
              "red": {
                "default": "#AE2A19",
                "bolder": "#601E16"
              },
              "orange": {
                "default": "#974F0C",
                "bolder": "#5F3811"
              },
              "yellow": {
                "default": "#7F5F01",
                "bolder": "#533F04"
              },
              "green": {
                "default": "#216E4E",
                "bolder": "#164B35"
              },
              "purple": {
                "default": "#5E4DB2",
                "bolder": "#352C63"
              },
              "teal": {
                "default": "#206B74",
                "bolder": "#1D474C"
              },
              "magenta": {
                "default": "#943D73",
                "bolder": "#50253F"
              }
            }
          },
          "icon": {
            "default": "#44546F",
            "subtle": "#626F86",
            "inverse": "#FFFFFF",
            "disabled": "#8993A5",
            "brand": "#0C66E4",
            "selected": "#0C66E4",
            "danger": "#E34935",
            "warning": {
              "default": "#D97008",
              "inverse": "#172B4D"
            },
            "success": "#22A06B",
            "discovery": "#8270DB",
            "information": "#1D7AFC",
            "accent": {
              "blue": "#1D7AFC",
              "red": "#E34935",
              "orange": "#D97008",
              "yellow": "#B38600",
              "green": "#22A06B",
              "purple": "#8270DB",
              "teal": "#1D9AAA",
              "magenta": "#CD519D"
            }
          },
          "border": {
            "default": "#DFE1E6",
            "inverse": "#FFFFFF",
            "focused": "#388BFF",
            "input": "#091e4224",
            "disabled": "#091E420F",
            "brand": "#0C66E4",
            "selected": "#0C66E4",
            "danger": "#E34935",
            "warning": "#D97008",
            "success": "#22A06B",
            "discovery": "#8270DB",
            "information": "#1D7AFC",
            "accent": {
              "blue": "#1D7AFC",
              "red": "#E34935",
              "orange": "#D97008",
              "yellow": "#B38600",
              "green": "#22A06B",
              "purple": "#8270DB",
              "teal": "#1D9AAA",
              "magenta": "#CD519D"
            },
            "muted": "hsla(223,12%,92%,1)",
            "subtle": "rgba(9,10,11,0.15)"
          },
          "mktg": {
            "surface": {
              "default": "#FFFFFF"
            },
            "text": {
              "default": "#212525",
              "inverse": "#FFFFFF"
            },
            "icon": {
              "default": "#212525"
            },
            "border": {
              "default": "#D3D8D8"
            },
            "btn": {
              "base": {
                "background": {
                  "default": "#D3D8D8",
                  "hover": "#B8C0C0",
                  "active": "#9EA7A7",
                  "disabled": "#EEF0F0",
                  "selected": "#838F8F",
                  "focusSelected": "#838F8F"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#D3D8D8",
                  "selected": "#151717",
                  "focusSelected": "#151717"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#397BFF",
                  "offset": "#F5F5F5",
                  "disabled": "#EEF0F0"
                }
              },
              "primary": {
                "background": {
                  "disabled": "#EEF0F0"
                },
                "color": {
                  "default": "#FFFFFF",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#D3D8D8",
                  "selected": "#FFFFFF",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#EEF0F0"
                }
              },
              "secondary": {
                "background": {
                  "default": "#FFFFFF",
                  "disabled": "#EEF0F0"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#D3D8D8",
                  "selected": "#ffffff",
                  "focusSelected": "#ffffff"
                },
                "border": {
                  "default": "#212525",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#EEF0F0"
                }
              },
              "outline": {
                "background": {
                  "default": "#FFFFFF",
                  "hover": "#EEF0F0",
                  "active": "#B8C0C0",
                  "disabled": "#EEF0F0",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#D3D8D8",
                  "selected": "#212525",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "#151717",
                  "hover": "#212525",
                  "active": "#394040",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#EEF0F0"
                }
              },
              "outlineSubtle": {
                "background": {
                  "default": "#EEF0F0",
                  "hover": "#D3D8D8",
                  "active": "#B8C0C0",
                  "disabled": "#FFFFFF",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#D3D8D8",
                  "selected": "#212525",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "#D3D8D8",
                  "hover": "#D3D8D8",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#FFFFFF"
                }
              },
              "subtle": {
                "background": {
                  "default": "#FFFFFF",
                  "hover": "#F5F5F5",
                  "active": "#D3D8D8",
                  "disabled": "#FFFFFF",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#D3D8D8",
                  "selected": "#212525",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#FFFFFF"
                }
              },
              "link": {
                "background": {
                  "default": "#FFFFFF",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#FFFFFF",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#D3D8D8",
                  "selected": "#212525",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#FFFFFF"
                }
              },
              "linkSubtle": {
                "background": {
                  "default": "#FFFFFF",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#FFFFFF",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#D3D8D8",
                  "selected": "#212525",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#FFFFFF"
                }
              },
              "hub": {
                "background": {
                  "disabled": "#EEF0F0"
                },
                "color": {
                  "default": "#FFFFFF",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#D3D8D8",
                  "selected": "#FFFFFF",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#EEF0F0"
                }
              }
            },
            "zurich": {
              "text": {
                "default": "#212121",
                "subtle": "#919191",
                "subtlest": "#E0E0E0",
                "inverse": "#EEEEEE"
              },
              "surface": {
                "default": "#C9DCE7",
                "raised": "#94BCD3"
              },
              "border": {
                "default": "#9E9E9E",
                "accent": {
                  "orange": "#FFAB40",
                  "yellow": "#EEFF41",
                  "blue": "rgb(66, 133, 244)",
                  "magenta": "#E37CAE"
                },
                "information": "#4285F4"
              },
              "background": {
                "neutral": {
                  "default": "#E2EDF3",
                  "bold": "#ACC4DC"
                },
                "information": {
                  "bold": {
                    "default": "#4285F4",
                    "hover": "#0E61EC"
                  }
                },
                "discovery": {
                  "bold": {
                    "default": "#B99AD7",
                    "hover": "#9A67CD"
                  }
                },
                "accent": {
                  "blue": "rgb(66, 133, 244)",
                  "teal": "#0097A7",
                  "orange": "#FFAB40",
                  "yellow": "#EEFF41",
                  "sky": "#C9DCE7",
                  "gray": "#212121"
                },
                "danger": {
                  "default": "#E35D5D"
                }
              },
              "icon": {
                "default": "#595959",
                "success": "#5DE36B",
                "danger": "#E35D5D"
              },
              "btn": {
                "primary": {
                  "text": "#EEEEEE",
                  "background": "#6A9FF6",
                  "activeBg": "#0E61EC",
                  "activeText": "#EEEEEE",
                  "focusRing": "#FFAB40"
                }
              }
            }
          },
          "prism": {
            "fuegokit": {
              "plainBackground": "#24292f",
              "property": "#8BDBE5",
              "tag": "#388BFF",
              "important": "#388BFF",
              "string": "#DA62AC",
              "boolean": "#9F8FEF"
            }
          },
          "card": {
            "background": "#FAFBFC",
            "border": "#8993A4",
            "heading": "#172B4D",
            "bodyText": "#2C3E5D",
            "buttonBg": "#0055CC",
            "buttonBgHover": "#388BFF",
            "buttonFg": "#ffffff"
          },
          "footerCard": {
            "background": "#ffffff"
          },
          "heading": {
            "h100": {
              "fg": "#44546F"
            },
            "h200": {
              "fg": "#44546F"
            },
            "h300": {
              "fg": "#172B4D"
            },
            "h400": {
              "fg": "#172B4D"
            },
            "h500": {
              "fg": "#172B4D"
            },
            "h600": {
              "fg": "#172B4D"
            },
            "h700": {
              "fg": "#172B4D"
            },
            "h800": {
              "fg": "#172B4D"
            },
            "h900": {
              "fg": "#172B4D"
            }
          },
          "surface": {
            "default": "#FFFFFF",
            "sunken": "#F7F8F9",
            "raised": "#FFFFFF",
            "overlay": "#FFFFFF"
          },
          "neutral": {
            "text": "#172B4D",
            "default": "#091E420F",
            "bold": "#44546F"
          },
          "information": {
            "text": "#1D7AFC",
            "default": "#E9F2FF",
            "bold": "#0C66E4"
          },
          "success": {
            "text": "#216E4E",
            "default": "#DFFCF0",
            "bold": "#1F845A"
          },
          "warning": {
            "text": "#974F0C",
            "default": "#FFF7D6",
            "bold": "#E2B203"
          },
          "discovery": {
            "text": "#5E4DB2",
            "default": "#F3F0FF",
            "bold": "#6E5DC6"
          },
          "danger": {
            "text": "#AE2A19",
            "default": "#FFEDEB",
            "bold": "#CA3521"
          }
        },
        "shadows": {
          "shadow": {
            "raised": "rgb(9 30 66 / 25%) 0px 1px 1px, rgb(9 30 66 / 31%) 0px 0px 1px",
            "overlay": "rgb(9 30 66 / 8%) 0px 8px 8px, rgb(9 30 66 / 12%) 0px 0px 1px",
            "overflow": "rgb(9 30 66 / 8%) 0px 8px 8px, rgb(9 30 66 / 12%) 0px 0px 1px"
          }
        }
      },
      "light_high_contrast": {
        "colors": {
          "background": {
            "neutral": {
              "default": "#091E420F",
              "hovered": "#091e4224",
              "pressed": "#091e424f",
              "subtle": {
                "default": "#FFFFFF",
                "hovered": "#091E420F",
                "pressed": "#091e4224"
              },
              "bold": {
                "default": "#44546F",
                "hovered": "#2C3E5D",
                "pressed": "#172B4D"
              }
            },
            "accent": {
              "blue": {
                "subtlest": "#E9F2FF",
                "subtler": "#CCE0FF",
                "subtle": "#85B8FF",
                "bolder": "#0C66E4"
              },
              "red": {
                "subtlest": "#FFEDEB",
                "subtler": "#FFD2CC",
                "subtle": "#F87462",
                "bolder": "#AE2A19"
              },
              "orange": {
                "subtlest": "#FFF4E5",
                "subtler": "#FFE2BD",
                "subtle": "#FAA53D",
                "bolder": "#B65C02"
              },
              "yellow": {
                "subtlest": "#FFFAE6",
                "subtler": "#FFF0B3",
                "subtle": "#FFE380",
                "bolder": "#FF991F"
              },
              "green": {
                "subtlest": "#DFFCF0",
                "subtler": "#BAF3DB",
                "subtle": "#2ABB7F",
                "bolder": "#1F845A"
              },
              "teal": {
                "subtlest": "#E3FAFC",
                "subtler": "#C1F0F5",
                "subtle": "#37B4C3",
                "bolder": "#1D7F8C"
              },
              "purple": {
                "subtlest": "#F3F0FF",
                "subtler": "#DFD8FD",
                "subtle": "#8F7EE7",
                "bolder": "#6E5DC6"
              },
              "magenta": {
                "subtlest": "#FFECF8",
                "subtler": "#FDD0EC",
                "subtle": "#DA62AC",
                "bolder": "#AE4787"
              },
              "gray": {
                "subtlest": "#FFFFFF",
                "subtler": "#F7F8F9",
                "subtle": "#B3B9C4",
                "bolder": "#758195"
              }
            },
            "disabled": "#091E420F",
            "inverse": {
              "subtle": {
                "default": "rgba(255,255,255,0.16)",
                "hovered": "rgba(255,255,255,0.24)",
                "pressed": "rgba(255,255,255,0.32)"
              }
            },
            "input": {
              "default": "#FFFFFF",
              "hovered": "#F7F8F9",
              "pressed": "#FFFFFF"
            },
            "brand": {
              "bold": {
                "default": "#0C66E4",
                "hovered": "#0055CC",
                "pressed": "#09326C"
              },
              "hovered": "#0055CC",
              "pressed": "#09326C"
            },
            "selected": {
              "default": "#E9F2FF",
              "hovered": "#CCE0FF",
              "pressed": "#85B8FF",
              "bold": {
                "default": "#0C66E4",
                "hovered": "#0055CC",
                "pressed": "#09326C"
              }
            },
            "danger": {
              "default": "#FFEDEB",
              "hovered": "#FFD2CC",
              "pressed": "#FF9C8F",
              "bold": {
                "default": "#CA3521",
                "hovered": "#AE2A19",
                "pressed": "#601E16"
              }
            },
            "warning": {
              "default": "#FFFAE6",
              "hovered": "#FFF0B3",
              "pressed": "#FFE380",
              "bold": {
                "default": "#FFC400",
                "hovered": "#E2B203",
                "pressed": "#FFAB00"
              }
            },
            "success": {
              "default": "#DFFCF0",
              "hovered": "#BAF3DB",
              "pressed": "#7EE2B8",
              "bold": {
                "default": "#1F845A",
                "hovered": "#216E4E",
                "pressed": "#164B35"
              }
            },
            "discovery": {
              "default": "#F3F0FF",
              "hovered": "#DFD8FD",
              "pressed": "#B8ACF6",
              "bold": {
                "default": "#6E5DC6",
                "hovered": "#5E4DB2",
                "pressed": "#352C63"
              }
            },
            "information": {
              "default": "#E9F2FF",
              "hovered": "#CCE0FF",
              "pressed": "#85B8FF",
              "bold": {
                "default": "#0C66E4",
                "hovered": "#0055CC",
                "pressed": "#09326C"
              }
            }
          },
          "blanket": {
            "default": "rgba(9,30,66,0.49)",
            "selected": "rgba(56,139,255,0.08)",
            "danger": "rgba(239,92,72,0.08)"
          },
          "skeleton": {
            "default": "#091E420F",
            "subtle": "#091E4208"
          },
          "interaction": {
            "hovered": "rgba(255,255,255,0.2)",
            "pressed": "rgba(255,255,255,0.36)",
            "inverse": {
              "hovered": "rgba(9,10,11,0.16)",
              "pressed": "rgba(9,10,11,0.32)"
            }
          },
          "link": {
            "default": "#0C66E4",
            "pressed": "#0055CC"
          },
          "elevation": {
            "surface": {
              "default": "#FFFFFF",
              "sunken": "#F7F8F9",
              "raised": "#FFFFFF",
              "overlay": "#FFFFFF"
            }
          },
          "text": {
            "default": "#172B4D",
            "subtle": "#44546F",
            "subtlest": "#626F86",
            "disabled": "#8993A5",
            "inverse": "#FFFFFF",
            "brand": "#0C66E4",
            "selected": "#0C66E4",
            "danger": "#AE2A19",
            "warning": {
              "default": "#974F0C",
              "inverse": "#172B4D"
            },
            "success": "#216E4E",
            "discovery": "#5E4DB2",
            "information": "#1D7AFC",
            "accent": {
              "blue": {
                "default": "#0055CC",
                "bolder": "#09326C"
              },
              "red": {
                "default": "#AE2A19",
                "bolder": "#601E16"
              },
              "orange": {
                "default": "#974F0C",
                "bolder": "#5F3811"
              },
              "yellow": {
                "default": "#FF8B00",
                "bolder": "#CF9F02"
              },
              "green": {
                "default": "#216E4E",
                "bolder": "#164B35"
              },
              "purple": {
                "default": "#5E4DB2",
                "bolder": "#352C63"
              },
              "teal": {
                "default": "#206B74",
                "bolder": "#1D474C"
              },
              "magenta": {
                "default": "#943D73",
                "bolder": "#50253F"
              }
            }
          },
          "icon": {
            "default": "#44546F",
            "subtle": "#626F86",
            "inverse": "#FFFFFF",
            "disabled": "#8993A5",
            "brand": "#0C66E4",
            "selected": "#0C66E4",
            "danger": "#E34935",
            "warning": {
              "default": "#D97008",
              "inverse": "#172B4D"
            },
            "success": "#22A06B",
            "discovery": "#8270DB",
            "information": "#1D7AFC",
            "accent": {
              "blue": "#1D7AFC",
              "red": "#E34935",
              "orange": "#D97008",
              "yellow": "#FFAB00",
              "green": "#22A06B",
              "purple": "#8270DB",
              "teal": "#1D9AAA",
              "magenta": "#CD519D"
            }
          },
          "border": {
            "default": "#DEE0E7",
            "inverse": "#FFFFFF",
            "focused": "#388BFF",
            "input": "#091e4224",
            "disabled": "#091E420F",
            "brand": "#0C66E4",
            "selected": "#0C66E4",
            "danger": "#E34935",
            "warning": "#D97008",
            "success": "#22A06B",
            "discovery": "#8270DB",
            "information": "#1D7AFC",
            "accent": {
              "blue": "#1D7AFC",
              "red": "#E34935",
              "orange": "#D97008",
              "yellow": "#FFAB00",
              "green": "#22A06B",
              "purple": "#8270DB",
              "teal": "#1D9AAA",
              "magenta": "#CD519D"
            },
            "muted": "hsla(227,16%,92%,1)",
            "subtle": "rgba(9,10,11,0.15)"
          },
          "mktg": {
            "surface": {
              "default": "#FFFFFF"
            },
            "text": {
              "default": "#212525",
              "inverse": "#FFFFFF"
            },
            "icon": {
              "default": "#212525"
            },
            "border": {
              "default": "#D3D8D8"
            },
            "btn": {
              "base": {
                "background": {
                  "default": "#D3D8D8",
                  "hover": "#B8C0C0",
                  "active": "#9EA7A7",
                  "disabled": "#EEF0F0",
                  "selected": "#838F8F",
                  "focusSelected": "#838F8F"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#D3D8D8",
                  "selected": "#151717",
                  "focusSelected": "#151717"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#397BFF",
                  "offset": "#F5F5F5",
                  "disabled": "#EEF0F0"
                }
              },
              "primary": {
                "background": {
                  "disabled": "#EEF0F0"
                },
                "color": {
                  "default": "#FFFFFF",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#D3D8D8",
                  "selected": "#FFFFFF",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#EEF0F0"
                }
              },
              "secondary": {
                "background": {
                  "default": "#FFFFFF",
                  "disabled": "#EEF0F0"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#D3D8D8",
                  "selected": "#ffffff",
                  "focusSelected": "#ffffff"
                },
                "border": {
                  "default": "#212525",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#EEF0F0"
                }
              },
              "outline": {
                "background": {
                  "default": "#FFFFFF",
                  "hover": "#EEF0F0",
                  "active": "#B8C0C0",
                  "disabled": "#EEF0F0",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#D3D8D8",
                  "selected": "#212525",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "#151717",
                  "hover": "#212525",
                  "active": "#394040",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#EEF0F0"
                }
              },
              "outlineSubtle": {
                "background": {
                  "default": "#EEF0F0",
                  "hover": "#D3D8D8",
                  "active": "#B8C0C0",
                  "disabled": "#FFFFFF",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#D3D8D8",
                  "selected": "#212525",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "#D3D8D8",
                  "hover": "#D3D8D8",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#FFFFFF"
                }
              },
              "subtle": {
                "background": {
                  "default": "#FFFFFF",
                  "hover": "#F5F5F5",
                  "active": "#D3D8D8",
                  "disabled": "#FFFFFF",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#D3D8D8",
                  "selected": "#212525",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#FFFFFF"
                }
              },
              "link": {
                "background": {
                  "default": "#FFFFFF",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#FFFFFF",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#D3D8D8",
                  "selected": "#212525",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#FFFFFF"
                }
              },
              "linkSubtle": {
                "background": {
                  "default": "#FFFFFF",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#FFFFFF",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#D3D8D8",
                  "selected": "#212525",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#FFFFFF"
                }
              },
              "hub": {
                "background": {
                  "disabled": "#EEF0F0"
                },
                "color": {
                  "default": "#FFFFFF",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#D3D8D8",
                  "selected": "#FFFFFF",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#EEF0F0"
                }
              }
            },
            "zurich": {
              "text": {
                "default": "#212121",
                "subtle": "#919191",
                "subtlest": "#E0E0E0",
                "inverse": "#EEEEEE"
              },
              "surface": {
                "default": "#C9DCE7",
                "raised": "#94BCD3"
              },
              "border": {
                "default": "#9E9E9E",
                "accent": {
                  "orange": "#FFAB40",
                  "yellow": "#EEFF41",
                  "blue": "rgb(66, 133, 244)",
                  "magenta": "#E37CAE"
                },
                "information": "#4285F4"
              },
              "background": {
                "neutral": {
                  "default": "#E2EDF3",
                  "bold": "#ACC4DC"
                },
                "information": {
                  "bold": {
                    "default": "#4285F4",
                    "hover": "#0E61EC"
                  }
                },
                "discovery": {
                  "bold": {
                    "default": "#B99AD7",
                    "hover": "#9A67CD"
                  }
                },
                "accent": {
                  "blue": "rgb(66, 133, 244)",
                  "teal": "#0097A7",
                  "orange": "#FFAB40",
                  "yellow": "#EEFF41",
                  "sky": "#C9DCE7",
                  "gray": "#212121"
                },
                "danger": {
                  "default": "#E35D5D"
                }
              },
              "icon": {
                "default": "#595959",
                "success": "#5DE36B",
                "danger": "#E35D5D"
              },
              "btn": {
                "primary": {
                  "text": "#EEEEEE",
                  "background": "#6A9FF6",
                  "activeBg": "#0E61EC",
                  "activeText": "#EEEEEE",
                  "focusRing": "#FFAB40"
                }
              }
            }
          },
          "prism": {
            "fuegokit": {
              "plainBackground": "#021727",
              "property": "#8BDBE5",
              "tag": "#388BFF",
              "important": "#388BFF",
              "string": "#DA62AC",
              "boolean": "#9F8FEF"
            }
          },
          "card": {
            "background": "#FFFFFF",
            "border": "#909BAD",
            "heading": "#172B4D",
            "bodyText": "#2C3E5D",
            "buttonBg": "#0055CC",
            "buttonBgHover": "#388BFF",
            "buttonFg": "#ffffff"
          },
          "footerCard": {
            "background": "#ffffff"
          },
          "heading": {
            "h100": {
              "fg": "#44546F"
            },
            "h200": {
              "fg": "#44546F"
            },
            "h300": {
              "fg": "#172B4D"
            },
            "h400": {
              "fg": "#172B4D"
            },
            "h500": {
              "fg": "#172B4D"
            },
            "h600": {
              "fg": "#172B4D"
            },
            "h700": {
              "fg": "#172B4D"
            },
            "h800": {
              "fg": "#172B4D"
            },
            "h900": {
              "fg": "#172B4D"
            }
          },
          "surface": {
            "default": "#FFFFFF",
            "sunken": "#F7F8F9",
            "raised": "#FFFFFF",
            "overlay": "#FFFFFF"
          },
          "neutral": {
            "text": "#172B4D",
            "default": "#091E420F",
            "bold": "#44546F"
          },
          "information": {
            "text": "#1D7AFC",
            "default": "#E9F2FF",
            "bold": "#0C66E4"
          },
          "success": {
            "text": "#216E4E",
            "default": "#DFFCF0",
            "bold": "#1F845A"
          },
          "warning": {
            "text": "#974F0C",
            "default": "#FFFAE6",
            "bold": "#FFC400"
          },
          "discovery": {
            "text": "#5E4DB2",
            "default": "#F3F0FF",
            "bold": "#6E5DC6"
          },
          "danger": {
            "text": "#AE2A19",
            "default": "#FFEDEB",
            "bold": "#CA3521"
          }
        },
        "shadows": {
          "shadow": {
            "raised": "rgb(9 30 66 / 25%) 0px 1px 1px, rgb(9 30 66 / 31%) 0px 0px 1px",
            "overlay": "rgb(9 30 66 / 8%) 0px 8px 8px, rgb(9 30 66 / 12%) 0px 0px 1px",
            "overflow": "rgb(9 30 66 / 8%) 0px 8px 8px, rgb(9 30 66 / 12%) 0px 0px 1px"
          }
        }
      },
      "light_colorblind": {
        "colors": {
          "background": {
            "neutral": {
              "default": "#091E420F",
              "hovered": "#091e4224",
              "pressed": "#091e424f",
              "subtle": {
                "default": "#FFFFFF",
                "hovered": "#091E420F",
                "pressed": "#091e4224"
              },
              "bold": {
                "default": "#44546F",
                "hovered": "#2C3E5D",
                "pressed": "#172B4D"
              }
            },
            "accent": {
              "blue": {
                "subtlest": "#E9F2FF",
                "subtler": "#CCE0FF",
                "subtle": "#85B8FF",
                "bolder": "#0C66E4"
              },
              "red": {
                "subtlest": "#FFEDEB",
                "subtler": "#FFD2CC",
                "subtle": "#F87462",
                "bolder": "#AE2A19"
              },
              "orange": {
                "subtlest": "#FFF4E5",
                "subtler": "#FFE2BD",
                "subtle": "#FAA53D",
                "bolder": "#B65C02"
              },
              "yellow": {
                "subtlest": "#FFFAE6",
                "subtler": "#FFF0B3",
                "subtle": "#FFE380",
                "bolder": "#FF991F"
              },
              "green": {
                "subtlest": "#DFFCF0",
                "subtler": "#BAF3DB",
                "subtle": "#2ABB7F",
                "bolder": "#1F845A"
              },
              "teal": {
                "subtlest": "#E3FAFC",
                "subtler": "#C1F0F5",
                "subtle": "#37B4C3",
                "bolder": "#1D7F8C"
              },
              "purple": {
                "subtlest": "#F3F0FF",
                "subtler": "#DFD8FD",
                "subtle": "#8F7EE7",
                "bolder": "#6E5DC6"
              },
              "magenta": {
                "subtlest": "#FFECF8",
                "subtler": "#FDD0EC",
                "subtle": "#DA62AC",
                "bolder": "#AE4787"
              },
              "gray": {
                "subtlest": "#FFFFFF",
                "subtler": "#F7F8F9",
                "subtle": "#B3B9C4",
                "bolder": "#758195"
              }
            },
            "disabled": "#091E420F",
            "inverse": {
              "subtle": {
                "default": "rgba(255,255,255,0.16)",
                "hovered": "rgba(255,255,255,0.24)",
                "pressed": "rgba(255,255,255,0.32)"
              }
            },
            "input": {
              "default": "#FFFFFF",
              "hovered": "#F7F8F9",
              "pressed": "#FFFFFF"
            },
            "brand": {
              "bold": {
                "default": "#0C66E4",
                "hovered": "#0055CC",
                "pressed": "#09326C"
              },
              "hovered": "#0055CC",
              "pressed": "#09326C"
            },
            "selected": {
              "default": "#E9F2FF",
              "hovered": "#CCE0FF",
              "pressed": "#85B8FF",
              "bold": {
                "default": "#0C66E4",
                "hovered": "#0055CC",
                "pressed": "#09326C"
              }
            },
            "danger": {
              "default": "#FFEDEB",
              "hovered": "#FFD2CC",
              "pressed": "#FF9C8F",
              "bold": {
                "default": "#CA3521",
                "hovered": "#AE2A19",
                "pressed": "#601E16"
              }
            },
            "warning": {
              "default": "#FFFAE6",
              "hovered": "#FFF0B3",
              "pressed": "#FFE380",
              "bold": {
                "default": "#FFC400",
                "hovered": "#E2B203",
                "pressed": "#FFAB00"
              }
            },
            "success": {
              "default": "#DFFCF0",
              "hovered": "#BAF3DB",
              "pressed": "#7EE2B8",
              "bold": {
                "default": "#1F845A",
                "hovered": "#216E4E",
                "pressed": "#164B35"
              }
            },
            "discovery": {
              "default": "#F3F0FF",
              "hovered": "#DFD8FD",
              "pressed": "#B8ACF6",
              "bold": {
                "default": "#6E5DC6",
                "hovered": "#5E4DB2",
                "pressed": "#352C63"
              }
            },
            "information": {
              "default": "#E9F2FF",
              "hovered": "#CCE0FF",
              "pressed": "#85B8FF",
              "bold": {
                "default": "#0C66E4",
                "hovered": "#0055CC",
                "pressed": "#09326C"
              }
            }
          },
          "blanket": {
            "default": "rgba(9,30,66,0.49)",
            "selected": "rgba(56,139,255,0.08)",
            "danger": "rgba(239,92,72,0.08)"
          },
          "skeleton": {
            "default": "#091E420F",
            "subtle": "#091E4208"
          },
          "interaction": {
            "hovered": "rgba(255,255,255,0.2)",
            "pressed": "rgba(255,255,255,0.36)",
            "inverse": {
              "hovered": "rgba(9,10,11,0.16)",
              "pressed": "rgba(9,10,11,0.32)"
            }
          },
          "link": {
            "default": "#0C66E4",
            "pressed": "#0055CC"
          },
          "elevation": {
            "surface": {
              "default": "#FFFFFF",
              "sunken": "#F7F8F9",
              "raised": "#FFFFFF",
              "overlay": "#FFFFFF"
            }
          },
          "text": {
            "default": "#172B4D",
            "subtle": "#44546F",
            "subtlest": "#626F86",
            "disabled": "#8993A5",
            "inverse": "#FFFFFF",
            "brand": "#0C66E4",
            "selected": "#0C66E4",
            "danger": "#AE2A19",
            "warning": {
              "default": "#974F0C",
              "inverse": "#172B4D"
            },
            "success": "#216E4E",
            "discovery": "#5E4DB2",
            "information": "#1D7AFC",
            "accent": {
              "blue": {
                "default": "#0055CC",
                "bolder": "#09326C"
              },
              "red": {
                "default": "#AE2A19",
                "bolder": "#601E16"
              },
              "orange": {
                "default": "#974F0C",
                "bolder": "#5F3811"
              },
              "yellow": {
                "default": "#FF8B00",
                "bolder": "#CF9F02"
              },
              "green": {
                "default": "#216E4E",
                "bolder": "#164B35"
              },
              "purple": {
                "default": "#5E4DB2",
                "bolder": "#352C63"
              },
              "teal": {
                "default": "#206B74",
                "bolder": "#1D474C"
              },
              "magenta": {
                "default": "#943D73",
                "bolder": "#50253F"
              }
            }
          },
          "icon": {
            "default": "#44546F",
            "subtle": "#626F86",
            "inverse": "#FFFFFF",
            "disabled": "#8993A5",
            "brand": "#0C66E4",
            "selected": "#0C66E4",
            "danger": "#E34935",
            "warning": {
              "default": "#D97008",
              "inverse": "#172B4D"
            },
            "success": "#22A06B",
            "discovery": "#8270DB",
            "information": "#1D7AFC",
            "accent": {
              "blue": "#1D7AFC",
              "red": "#E34935",
              "orange": "#D97008",
              "yellow": "#FFAB00",
              "green": "#22A06B",
              "purple": "#8270DB",
              "teal": "#1D9AAA",
              "magenta": "#CD519D"
            }
          },
          "border": {
            "default": "#DFE1E6",
            "inverse": "#FFFFFF",
            "focused": "#388BFF",
            "input": "#091e4224",
            "disabled": "#091E420F",
            "brand": "#0C66E4",
            "selected": "#0C66E4",
            "danger": "#E34935",
            "warning": "#D97008",
            "success": "#22A06B",
            "discovery": "#8270DB",
            "information": "#1D7AFC",
            "accent": {
              "blue": "#1D7AFC",
              "red": "#E34935",
              "orange": "#D97008",
              "yellow": "#FFAB00",
              "green": "#22A06B",
              "purple": "#8270DB",
              "teal": "#1D9AAA",
              "magenta": "#CD519D"
            },
            "muted": "hsla(223,12%,92%,1)",
            "subtle": "rgba(9,10,11,0.15)"
          },
          "mktg": {
            "surface": {
              "default": "#FFFFFF"
            },
            "text": {
              "default": "#212525",
              "inverse": "#FFFFFF"
            },
            "icon": {
              "default": "#212525"
            },
            "border": {
              "default": "#D3D8D8"
            },
            "btn": {
              "base": {
                "background": {
                  "default": "#D3D8D8",
                  "hover": "#B8C0C0",
                  "active": "#9EA7A7",
                  "disabled": "#EEF0F0",
                  "selected": "#838F8F",
                  "focusSelected": "#838F8F"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#D3D8D8",
                  "selected": "#151717",
                  "focusSelected": "#151717"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#397BFF",
                  "offset": "#F5F5F5",
                  "disabled": "#EEF0F0"
                }
              },
              "primary": {
                "background": {
                  "disabled": "#EEF0F0"
                },
                "color": {
                  "default": "#FFFFFF",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#D3D8D8",
                  "selected": "#FFFFFF",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#EEF0F0"
                }
              },
              "secondary": {
                "background": {
                  "default": "#FFFFFF",
                  "disabled": "#EEF0F0"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#D3D8D8",
                  "selected": "#ffffff",
                  "focusSelected": "#ffffff"
                },
                "border": {
                  "default": "#212525",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#EEF0F0"
                }
              },
              "outline": {
                "background": {
                  "default": "#FFFFFF",
                  "hover": "#EEF0F0",
                  "active": "#B8C0C0",
                  "disabled": "#EEF0F0",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#D3D8D8",
                  "selected": "#212525",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "#151717",
                  "hover": "#212525",
                  "active": "#394040",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#EEF0F0"
                }
              },
              "outlineSubtle": {
                "background": {
                  "default": "#EEF0F0",
                  "hover": "#D3D8D8",
                  "active": "#B8C0C0",
                  "disabled": "#FFFFFF",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#D3D8D8",
                  "selected": "#212525",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "#D3D8D8",
                  "hover": "#D3D8D8",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#FFFFFF"
                }
              },
              "subtle": {
                "background": {
                  "default": "#FFFFFF",
                  "hover": "#F5F5F5",
                  "active": "#D3D8D8",
                  "disabled": "#FFFFFF",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#D3D8D8",
                  "selected": "#212525",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#FFFFFF"
                }
              },
              "link": {
                "background": {
                  "default": "#FFFFFF",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#FFFFFF",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#D3D8D8",
                  "selected": "#212525",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#FFFFFF"
                }
              },
              "linkSubtle": {
                "background": {
                  "default": "#FFFFFF",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#FFFFFF",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#212525",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#D3D8D8",
                  "selected": "#212525",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#FFFFFF"
                }
              },
              "hub": {
                "background": {
                  "disabled": "#EEF0F0"
                },
                "color": {
                  "default": "#FFFFFF",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#D3D8D8",
                  "selected": "#FFFFFF",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#F5F5F5",
                  "disabled": "#EEF0F0"
                }
              }
            },
            "zurich": {
              "text": {
                "default": "#212121",
                "subtle": "#919191",
                "subtlest": "#E0E0E0",
                "inverse": "#EEEEEE"
              },
              "surface": {
                "default": "#C9DCE7",
                "raised": "#94BCD3"
              },
              "border": {
                "default": "#9E9E9E",
                "accent": {
                  "orange": "#FFAB40",
                  "yellow": "#EEFF41",
                  "blue": "rgb(66, 133, 244)",
                  "magenta": "#E37CAE"
                },
                "information": "#4285F4"
              },
              "background": {
                "neutral": {
                  "default": "#E2EDF3",
                  "bold": "#ACC4DC"
                },
                "information": {
                  "bold": {
                    "default": "#4285F4",
                    "hover": "#0E61EC"
                  }
                },
                "discovery": {
                  "bold": {
                    "default": "#B99AD7",
                    "hover": "#9A67CD"
                  }
                },
                "accent": {
                  "blue": "rgb(66, 133, 244)",
                  "teal": "#0097A7",
                  "orange": "#FFAB40",
                  "yellow": "#EEFF41",
                  "sky": "#C9DCE7",
                  "gray": "#212121"
                },
                "danger": {
                  "default": "#E35D5D"
                }
              },
              "icon": {
                "default": "#595959",
                "success": "#5DE36B",
                "danger": "#E35D5D"
              },
              "btn": {
                "primary": {
                  "text": "#EEEEEE",
                  "background": "#6A9FF6",
                  "activeBg": "#0E61EC",
                  "activeText": "#EEEEEE",
                  "focusRing": "#FFAB40"
                }
              }
            }
          },
          "prism": {
            "fuegokit": {
              "plainBackground": "#24292f",
              "property": "#8BDBE5",
              "tag": "#388BFF",
              "important": "#388BFF",
              "string": "#DA62AC",
              "boolean": "#9F8FEF"
            }
          },
          "card": {
            "background": "#F4F5F7",
            "border": "#8993A4",
            "heading": "#172B4D",
            "bodyText": "#2C3E5D",
            "buttonBg": "#0055CC",
            "buttonBgHover": "#388BFF",
            "buttonFg": "#ffffff"
          },
          "footerCard": {
            "background": "#ffffff"
          },
          "heading": {
            "h100": {
              "fg": "#44546F"
            },
            "h200": {
              "fg": "#44546F"
            },
            "h300": {
              "fg": "#172B4D"
            },
            "h400": {
              "fg": "#172B4D"
            },
            "h500": {
              "fg": "#172B4D"
            },
            "h600": {
              "fg": "#172B4D"
            },
            "h700": {
              "fg": "#172B4D"
            },
            "h800": {
              "fg": "#172B4D"
            },
            "h900": {
              "fg": "#172B4D"
            }
          },
          "surface": {
            "default": "#FFFFFF",
            "sunken": "#F7F8F9",
            "raised": "#FFFFFF",
            "overlay": "#FFFFFF"
          },
          "neutral": {
            "text": "#172B4D",
            "default": "#091E420F",
            "bold": "#44546F"
          },
          "information": {
            "text": "#1D7AFC",
            "default": "#E9F2FF",
            "bold": "#0C66E4"
          },
          "success": {
            "text": "#216E4E",
            "default": "#DFFCF0",
            "bold": "#1F845A"
          },
          "warning": {
            "text": "#974F0C",
            "default": "#FFFAE6",
            "bold": "#FFC400"
          },
          "discovery": {
            "text": "#5E4DB2",
            "default": "#F3F0FF",
            "bold": "#6E5DC6"
          },
          "danger": {
            "text": "#AE2A19",
            "default": "#FFEDEB",
            "bold": "#CA3521"
          }
        },
        "shadows": {
          "shadow": {
            "raised": "rgb(9 30 66 / 25%) 0px 1px 1px, rgb(9 30 66 / 31%) 0px 0px 1px",
            "overlay": "rgb(9 30 66 / 8%) 0px 8px 8px, rgb(9 30 66 / 12%) 0px 0px 1px",
            "overflow": "rgb(9 30 66 / 8%) 0px 8px 8px, rgb(9 30 66 / 12%) 0px 0px 1px"
          }
        }
      },
      "dark": {
        "colors": {
          "background": {
            "neutral": {
              "default": "#a1bdd914",
              "hovered": "#A6C5E229",
              "pressed": "#BFDBF847",
              "subtle": {
                "default": "#00000000",
                "hovered": "#a1bdd914",
                "pressed": "#A6C5E229"
              },
              "bold": {
                "default": "#9FADBC",
                "hovered": "#B6C2CF",
                "pressed": "#C7D1DB"
              }
            },
            "accent": {
              "blue": {
                "subtlest": "#082145",
                "subtler": "#09326C",
                "subtle": "#0055CC",
                "bolder": "#579DFF"
              },
              "red": {
                "subtlest": "#391813",
                "subtler": "#601E16",
                "subtle": "#AE2A19",
                "bolder": "#F87462"
              },
              "orange": {
                "subtlest": "#43290F",
                "subtler": "#5F3811",
                "subtle": "#974F0C",
                "bolder": "#FAA53D"
              },
              "yellow": {
                "subtlest": "#3D2E00",
                "subtler": "#533F04",
                "subtle": "#7F5F01",
                "bolder": "#E2B203"
              },
              "green": {
                "subtlest": "#133527",
                "subtler": "#164B35",
                "subtle": "#216E4E",
                "bolder": "#4BCE97"
              },
              "teal": {
                "subtlest": "#153337",
                "subtler": "#1D474C",
                "subtle": "#206B74",
                "bolder": "#60C6D2"
              },
              "purple": {
                "subtlest": "#231C3F",
                "subtler": "#352C63",
                "subtle": "#5E4DB2",
                "bolder": "#9F8FEF"
              },
              "magenta": {
                "subtlest": "#341829",
                "subtler": "#50253F",
                "subtle": "#943D73",
                "bolder": "#E774BB"
              },
              "gray": {
                "subtlest": "#B6C2CF",
                "subtler": "#9FADBC",
                "subtle": "#8696A7",
                "bolder": "#2C333A"
              }
            },
            "disabled": "#a1bdd914",
            "inverse": {
              "subtle": {
                "default": "rgba(255,255,255,0.16)",
                "hovered": "rgba(255,255,255,0.24)",
                "pressed": "rgba(255,255,255,0.32)"
              }
            },
            "input": {
              "default": "#1D2125",
              "hovered": "#22272B",
              "pressed": "#1D2125"
            },
            "brand": {
              "bold": {
                "default": "#579DFF",
                "hovered": "#85B8FF",
                "pressed": "#CCE0FF"
              },
              "hovered": "#85B8FF",
              "pressed": "#CCE0FF"
            },
            "selected": {
              "default": "#082145",
              "hovered": "#09326C",
              "pressed": "#0055CC",
              "bold": {
                "default": "#579DFF",
                "hovered": "#85B8FF",
                "pressed": "#CCE0FF"
              }
            },
            "danger": {
              "default": "#391813",
              "hovered": "#601E16",
              "pressed": "#AE2A19",
              "bold": {
                "default": "#F87462",
                "hovered": "#FF9C8F",
                "pressed": "#FFD2CC"
              }
            },
            "warning": {
              "default": "#3D2E00",
              "hovered": "#533F04",
              "pressed": "#7F5F01",
              "bold": {
                "default": "#E2B203",
                "hovered": "#F5CD47",
                "pressed": "#F8E6A0"
              }
            },
            "success": {
              "default": "#133527",
              "hovered": "#164B35",
              "pressed": "#216E4E",
              "bold": {
                "default": "#4BCE97",
                "hovered": "#7EE2B8",
                "pressed": "#BAF3DB"
              }
            },
            "discovery": {
              "default": "#231C3F",
              "hovered": "#352C63",
              "pressed": "#5E4DB2",
              "bold": {
                "default": "#9F8FEF",
                "hovered": "#B8ACF6",
                "pressed": "#DFD8FD"
              }
            },
            "information": {
              "default": "#082145",
              "hovered": "#09326C",
              "pressed": "#0055CC",
              "bold": {
                "default": "#579DFF",
                "hovered": "#85B8FF",
                "pressed": "#CCE0FF"
              }
            }
          },
          "blanket": {
            "default": "rgba(3,4,4,0.26)",
            "selected": "rgba(29,122,252,0.08)",
            "danger": "rgba(227,73,53,0.08)"
          },
          "skeleton": {
            "default": "#a1bdd914",
            "subtle": "#bcd6f00a"
          },
          "interaction": {
            "hovered": "rgba(0,0,0,0.16)",
            "pressed": "rgba(0,0,0,0.32)",
            "inverse": {
              "hovered": "rgba(255,255,255,0.2)",
              "pressed": "rgba(9,10,11,0.36)"
            }
          },
          "link": {
            "default": "#579DFF",
            "pressed": "#85B8FF"
          },
          "elevation": {
            "surface": {
              "default": "#161A1D",
              "sunken": "#161A1D",
              "raised": "#1D2125",
              "overlay": "#22272B"
            }
          },
          "text": {
            "default": "#B6C2CF",
            "subtle": "#9FADBC",
            "subtlest": "#8696A7",
            "disabled": "#5C6C7A",
            "inverse": "#161A1D",
            "brand": "#579DFF",
            "selected": "#579DFF",
            "danger": "#FF9C8F",
            "warning": {
              "default": "#F5CD47",
              "inverse": "#161A1D"
            },
            "success": "#7EE2B8",
            "discovery": "#B8ACF6",
            "information": "#85B8FF",
            "accent": {
              "blue": {
                "default": "#85B8FF",
                "bolder": "#CCE0FF"
              },
              "red": {
                "default": "#FF9C8F",
                "bolder": "#FFD2CC"
              },
              "orange": {
                "default": "#FEC57B",
                "bolder": "#FFE2BD"
              },
              "yellow": {
                "default": "#F5CD47",
                "bolder": "#F8E6A0"
              },
              "green": {
                "default": "#7EE2B8",
                "bolder": "#BAF3DB"
              },
              "purple": {
                "default": "#B8ACF6",
                "bolder": "#DFD8FD"
              },
              "teal": {
                "default": "#8BDBE5",
                "bolder": "#C1F0F5"
              },
              "magenta": {
                "default": "#F797D2",
                "bolder": "#FDD0EC"
              }
            }
          },
          "icon": {
            "default": "#9FADBC",
            "subtle": "#8696A7",
            "inverse": "#161A1D",
            "disabled": "#5C6C7A",
            "brand": "#579DFF",
            "selected": "#579DFF",
            "danger": "#EF5C48",
            "warning": {
              "default": "#CF9F02",
              "inverse": "#161A1D"
            },
            "success": "#2ABB7F",
            "discovery": "#8F7EE7",
            "information": "#388BFF",
            "accent": {
              "blue": "#388BFF",
              "red": "#EF5C48",
              "orange": "#F18D13",
              "yellow": "#CF9F02",
              "green": "#2ABB7F",
              "purple": "#8F7EE7",
              "teal": "#37B4C3",
              "magenta": "#DA62AC"
            }
          },
          "border": {
            "default": "#505F79",
            "inverse": "#161A1D",
            "focused": "#85B8FF",
            "input": "#A6C5E229",
            "disabled": "#a1bdd914",
            "brand": "#579DFF",
            "selected": "#579DFF",
            "danger": "#EF5C48",
            "warning": "#CF9F02",
            "success": "#2ABB7F",
            "discovery": "#8F7EE7",
            "information": "#388BFF",
            "accent": {
              "blue": "#388BFF",
              "red": "#EF5C48",
              "orange": "#F18D13",
              "yellow": "#CF9F02",
              "green": "#2ABB7F",
              "purple": "#8F7EE7",
              "teal": "#37B4C3",
              "magenta": "#DA62AC"
            },
            "muted": "#344563",
            "subtle": "rgba(250,251,252,0.1)"
          },
          "mktg": {
            "surface": {
              "default": "#151717"
            },
            "text": {
              "default": "#FFFFFF",
              "inverse": "#151717"
            },
            "icon": {
              "default": "#FFFFFF"
            },
            "border": {
              "default": "#394040"
            },
            "btn": {
              "base": {
                "background": {
                  "default": "#6A7575",
                  "hover": "#838F8F",
                  "active": "#9EA7A7",
                  "disabled": "#212525",
                  "selected": "#9EA7A7",
                  "focusSelected": "#9EA7A7"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#F5F5F5",
                  "active": "#FFFFFF",
                  "disabled": "#515B5B",
                  "selected": "#F5F5F5",
                  "focusSelected": "#F5F5F5"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#397BFF",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              },
              "primary": {
                "background": {
                  "disabled": "#212525"
                },
                "color": {
                  "default": "#ffffff",
                  "hover": "#ffffff",
                  "active": "#ffffff",
                  "disabled": "#515B5B",
                  "selected": "#ffffff",
                  "focusSelected": "#ffffff"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              },
              "secondary": {
                "background": {
                  "disabled": "#212525"
                },
                "color": {
                  "default": "#ffffff",
                  "hover": "#ffffff",
                  "active": "#ffffff",
                  "disabled": "#515B5B",
                  "selected": "#ffffff",
                  "focusSelected": "#ffffff"
                },
                "border": {
                  "default": "#FFFFFF",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              },
              "outline": {
                "background": {
                  "default": "#212525",
                  "hover": "#394040",
                  "active": "#515B5B",
                  "disabled": "#212525",
                  "selected": "#394040",
                  "focusSelected": "#394040"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#F5F5F5",
                  "active": "#F5F5F5",
                  "disabled": "#515B5B",
                  "selected": "#FFFFFF",
                  "focusSelected": "#161A1D"
                },
                "border": {
                  "default": "#FFFFFF",
                  "hover": "#F5F5F5",
                  "active": "#EEF0F0",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              },
              "outlineSubtle": {
                "background": {
                  "default": "#151717",
                  "hover": "#394040",
                  "active": "#515B5B",
                  "disabled": "#212525",
                  "selected": "#394040",
                  "focusSelected": "#394040"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#F5F5F5",
                  "active": "#F5F5F5",
                  "disabled": "#515B5B",
                  "selected": "#FFFFFF",
                  "focusSelected": "#161A1D"
                },
                "border": {
                  "default": "#394040",
                  "hover": "#394040",
                  "focus": "#a044b9",
                  "disabled": "#212525",
                  "offset": "#151717"
                }
              },
              "subtle": {
                "background": {
                  "default": "#151717",
                  "hover": "#212525",
                  "active": "#394040",
                  "disabled": "#151717",
                  "selected": "#394040",
                  "focusSelected": "#394040"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#F5F5F5",
                  "active": "#F5F5F5",
                  "disabled": "#515B5B",
                  "selected": "#FFFFFF",
                  "focusSelected": "#161A1D"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#151717"
                }
              },
              "link": {
                "background": {
                  "default": "#151717",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#151717",
                  "selected": "#151717",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#515B5B",
                  "selected": "#EEF0F0",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#151717"
                }
              },
              "linkSubtle": {
                "background": {
                  "default": "#151717",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#151717",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#838F8F",
                  "hover": "#9EA7A7",
                  "active": "#B8C0C0",
                  "disabled": "#515B5B",
                  "selected": "#EEF0F0",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#151717"
                }
              },
              "hub": {
                "background": {
                  "disabled": "#212525"
                },
                "color": {
                  "default": "#FFFFFF",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#515B5B",
                  "selected": "#FFFFFF",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              }
            },
            "zurich": {
              "text": {
                "default": "#212121",
                "subtle": "#919191",
                "subtlest": "#E0E0E0",
                "inverse": "#EEEEEE"
              },
              "surface": {
                "default": "#C9DCE7",
                "raised": "#94BCD3"
              },
              "border": {
                "default": "#9E9E9E",
                "accent": {
                  "orange": "#FFAB40",
                  "yellow": "#EEFF41",
                  "blue": "rgb(66, 133, 244)",
                  "magenta": "#E37CAE"
                },
                "information": "#4285F4"
              },
              "background": {
                "neutral": {
                  "default": "#E2EDF3",
                  "bold": "#ACC4DC"
                },
                "information": {
                  "bold": {
                    "default": "#4285F4",
                    "hover": "#0E61EC"
                  }
                },
                "discovery": {
                  "bold": {
                    "default": "#B99AD7",
                    "hover": "#9A67CD"
                  }
                },
                "accent": {
                  "blue": "rgb(66, 133, 244)",
                  "teal": "#0097A7",
                  "orange": "#FFAB40",
                  "yellow": "#EEFF41",
                  "sky": "#C9DCE7",
                  "gray": "#212121"
                },
                "danger": {
                  "default": "#E35D5D"
                }
              },
              "icon": {
                "default": "#595959",
                "success": "#5DE36B",
                "danger": "#E35D5D"
              },
              "btn": {
                "primary": {
                  "text": "#EEEEEE",
                  "background": "#6A9FF6",
                  "activeBg": "#0E61EC",
                  "activeText": "#EEEEEE",
                  "focusRing": "#FFAB40"
                }
              }
            }
          },
          "prism": {
            "fuegokit": {
              "plainBackground": "#2C333A",
              "property": "#8BDBE5",
              "tag": "#388BFF",
              "important": "#388BFF",
              "string": "#DA62AC",
              "boolean": "#9F8FEF"
            }
          },
          "card": {
            "background": "#2C333A",
            "border": "#9FADBC",
            "heading": "#B5BEC9",
            "bodyText": "#DEE4EA",
            "buttonBg": "#579DFF",
            "buttonBgHover": "#388BFF",
            "buttonFg": "#082145"
          },
          "footerCard": {
            "background": "#2C333A"
          },
          "heading": {
            "h100": {
              "fg": "#9FADBC"
            },
            "h200": {
              "fg": "#9FADBC"
            },
            "h300": {
              "fg": "#C7D1DB"
            },
            "h400": {
              "fg": "#C7D1DB"
            },
            "h500": {
              "fg": "#C7D1DB"
            },
            "h600": {
              "fg": "#C7D1DB"
            },
            "h700": {
              "fg": "#C7D1DB"
            },
            "h800": {
              "fg": "#C7D1DB"
            },
            "h900": {
              "fg": "#C7D1DB"
            }
          },
          "surface": {
            "default": "#161A1D",
            "sunken": "#161A1D",
            "raised": "#1D2125",
            "overlay": "#22272B"
          },
          "neutral": {
            "text": "#B6C2CF",
            "default": "#a1bdd914",
            "bold": "#9FADBC"
          },
          "information": {
            "text": "#B6C2CF",
            "default": "#082145",
            "bold": "#579DFF"
          },
          "success": {
            "text": "#7EE2B8",
            "default": "#133527",
            "bold": "#4BCE97"
          },
          "warning": {
            "text": "#F5CD47",
            "default": "#3D2E00",
            "bold": "#E2B203"
          },
          "discovery": {
            "text": "#B8ACF6",
            "default": "#231C3F",
            "bold": "#9F8FEF"
          },
          "danger": {
            "text": "#FF9C8F",
            "default": "#391813",
            "bold": "#F87462"
          }
        },
        "shadows": {
          "shadow": {
            "raised": "rgb(3 4 4 / 50%) 0px 1px 1px, rgb(3 4 4 / 50%) 0px 0px 1px;",
            "overlay": "rgba(188, 214, 240, 0.04) 0px 0px 0px, rgba(3, 4, 4, 0.36) 0px 8px 12px, rgba(3, 4, 4, 0.5) 0px 0px 1px",
            "overflow": "rgb(3 4 4 / 56%) 0px 0px 12px, rgb(3 4 4 / 50%) 0px 0px 1px"
          }
        }
      },
      "dark_dimmed": {
        "colors": {
          "background": {
            "neutral": {
              "default": "#a1bdd914",
              "hovered": "#A6C5E229",
              "pressed": "#BFDBF847",
              "subtle": {
                "default": "#000000",
                "hovered": "#a1bdd914",
                "pressed": "#A6C5E229"
              },
              "bold": {
                "default": "#9FADBC",
                "hovered": "#B6C2CF",
                "pressed": "#C7D1DB"
              }
            },
            "accent": {
              "blue": {
                "subtlest": "#082145",
                "subtler": "#09326C",
                "subtle": "#0055CC",
                "bolder": "#579DFF"
              },
              "red": {
                "subtlest": "#391813",
                "subtler": "#601E16",
                "subtle": "#AE2A19",
                "bolder": "#F87462"
              },
              "orange": {
                "subtlest": "#43290F",
                "subtler": "#5F3811",
                "subtle": "#974F0C",
                "bolder": "#FAA53D"
              },
              "yellow": {
                "subtlest": "#B38600",
                "subtler": "#CF9F02",
                "subtle": "#FF8B00",
                "bolder": "#FFC400"
              },
              "green": {
                "subtlest": "#133527",
                "subtler": "#164B35",
                "subtle": "#216E4E",
                "bolder": "#4BCE97"
              },
              "teal": {
                "subtlest": "#153337",
                "subtler": "#1D474C",
                "subtle": "#206B74",
                "bolder": "#60C6D2"
              },
              "purple": {
                "subtlest": "#231C3F",
                "subtler": "#352C63",
                "subtle": "#5E4DB2",
                "bolder": "#9F8FEF"
              },
              "magenta": {
                "subtlest": "#341829",
                "subtler": "#50253F",
                "subtle": "#943D73",
                "bolder": "#E774BB"
              },
              "gray": {
                "subtlest": "#B6C2CF",
                "subtler": "#9FADBC",
                "subtle": "#8696A7",
                "bolder": "#2C333A"
              }
            },
            "disabled": "#a1bdd914",
            "inverse": {
              "subtle": {
                "default": "rgba(255,255,255,0.16)",
                "hovered": "rgba(255,255,255,0.24)",
                "pressed": "rgba(255,255,255,0.32)"
              }
            },
            "input": {
              "default": "#1D2125",
              "hovered": "#22272B",
              "pressed": "#1D2125"
            },
            "brand": {
              "bold": {
                "default": "#579DFF",
                "hovered": "#85B8FF",
                "pressed": "#CCE0FF"
              },
              "hovered": "#85B8FF",
              "pressed": "#CCE0FF"
            },
            "selected": {
              "default": "#082145",
              "hovered": "#09326C",
              "pressed": "#0055CC",
              "bold": {
                "default": "#579DFF",
                "hovered": "#85B8FF",
                "pressed": "#CCE0FF"
              }
            },
            "danger": {
              "default": "#391813",
              "hovered": "#601E16",
              "pressed": "#AE2A19",
              "bold": {
                "default": "#F87462",
                "hovered": "#FF9C8F",
                "pressed": "#FFD2CC"
              }
            },
            "warning": {
              "default": "#B38600",
              "hovered": "#CF9F02",
              "pressed": "#FF8B00",
              "bold": {
                "default": "#FFC400",
                "hovered": "#FFE380",
                "pressed": "#FFF0B3"
              }
            },
            "success": {
              "default": "#133527",
              "hovered": "#164B35",
              "pressed": "#216E4E",
              "bold": {
                "default": "#4BCE97",
                "hovered": "#7EE2B8",
                "pressed": "#BAF3DB"
              }
            },
            "discovery": {
              "default": "#231C3F",
              "hovered": "#352C63",
              "pressed": "#5E4DB2",
              "bold": {
                "default": "#9F8FEF",
                "hovered": "#B8ACF6",
                "pressed": "#DFD8FD"
              }
            },
            "information": {
              "default": "#082145",
              "hovered": "#09326C",
              "pressed": "#0055CC",
              "bold": {
                "default": "#579DFF",
                "hovered": "#85B8FF",
                "pressed": "#CCE0FF"
              }
            }
          },
          "blanket": {
            "default": "rgba(3,4,4,0.26)",
            "selected": "rgba(29,122,252,0.08)",
            "danger": "rgba(227,73,53,0.08)"
          },
          "skeleton": {
            "default": "#a1bdd914",
            "subtle": "#bcd6f00a"
          },
          "interaction": {
            "hovered": "rgba(0,0,0,0.16)",
            "pressed": "rgba(0,0,0,0.32)",
            "inverse": {
              "hovered": "rgba(255,255,255,0.2)",
              "pressed": "rgba(9,10,11,0.36)"
            }
          },
          "link": {
            "default": "#579DFF",
            "pressed": "#85B8FF"
          },
          "elevation": {
            "surface": {
              "default": "#161A1D",
              "sunken": "#161A1D",
              "raised": "#1D2125",
              "overlay": "#22272B"
            }
          },
          "text": {
            "default": "#B6C2CF",
            "subtle": "#9FADBC",
            "subtlest": "#8696A7",
            "disabled": "#5C6C7A",
            "inverse": "#161A1D",
            "brand": "#579DFF",
            "selected": "#579DFF",
            "danger": "#FF9C8F",
            "warning": {
              "default": "#FFE380",
              "inverse": "#161A1D"
            },
            "success": "#7EE2B8",
            "discovery": "#B8ACF6",
            "information": "#85B8FF",
            "accent": {
              "blue": {
                "default": "#85B8FF",
                "bolder": "#CCE0FF"
              },
              "red": {
                "default": "#FF9C8F",
                "bolder": "#FFD2CC"
              },
              "orange": {
                "default": "#FEC57B",
                "bolder": "#FFE2BD"
              },
              "yellow": {
                "default": "#FFE380",
                "bolder": "#FFF0B3"
              },
              "green": {
                "default": "#7EE2B8",
                "bolder": "#BAF3DB"
              },
              "purple": {
                "default": "#B8ACF6",
                "bolder": "#DFD8FD"
              },
              "teal": {
                "default": "#8BDBE5",
                "bolder": "#C1F0F5"
              },
              "magenta": {
                "default": "#F797D2",
                "bolder": "#FDD0EC"
              }
            }
          },
          "icon": {
            "default": "#9FADBC",
            "subtle": "#8696A7",
            "inverse": "#161A1D",
            "disabled": "#5C6C7A",
            "brand": "#579DFF",
            "selected": "#579DFF",
            "danger": "#EF5C48",
            "warning": {
              "default": "#E2B203",
              "inverse": "#161A1D"
            },
            "success": "#2ABB7F",
            "discovery": "#8F7EE7",
            "information": "#388BFF",
            "accent": {
              "blue": "#388BFF",
              "red": "#EF5C48",
              "orange": "#F18D13",
              "yellow": "#E2B203",
              "green": "#2ABB7F",
              "purple": "#8F7EE7",
              "teal": "#37B4C3",
              "magenta": "#DA62AC"
            }
          },
          "border": {
            "default": "#313A4A",
            "inverse": "#161A1D",
            "focused": "#85B8FF",
            "input": "#A6C5E229",
            "disabled": "#a1bdd914",
            "brand": "#579DFF",
            "selected": "#579DFF",
            "danger": "#EF5C48",
            "warning": "#E2B203",
            "success": "#2ABB7F",
            "discovery": "#8F7EE7",
            "information": "#388BFF",
            "accent": {
              "blue": "#388BFF",
              "red": "#EF5C48",
              "orange": "#F18D13",
              "yellow": "#E2B203",
              "green": "#2ABB7F",
              "purple": "#8F7EE7",
              "teal": "#37B4C3",
              "magenta": "#DA62AC"
            },
            "muted": "#273349",
            "subtle": "rgba(214,215,217,0.1)"
          },
          "mktg": {
            "surface": {
              "default": "#151717"
            },
            "text": {
              "default": "#FFFFFF",
              "inverse": "#151717"
            },
            "icon": {
              "default": "#FFFFFF"
            },
            "border": {
              "default": "#394040"
            },
            "btn": {
              "base": {
                "background": {
                  "default": "#6A7575",
                  "hover": "#838F8F",
                  "active": "#9EA7A7",
                  "disabled": "#212525",
                  "selected": "#9EA7A7",
                  "focusSelected": "#9EA7A7"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#F5F5F5",
                  "active": "#FFFFFF",
                  "disabled": "#515B5B",
                  "selected": "#F5F5F5",
                  "focusSelected": "#F5F5F5"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#397BFF",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              },
              "primary": {
                "background": {
                  "disabled": "#212525"
                },
                "color": {
                  "default": "#ffffff",
                  "hover": "#ffffff",
                  "active": "#ffffff",
                  "disabled": "#515B5B",
                  "selected": "#ffffff",
                  "focusSelected": "#ffffff"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              },
              "secondary": {
                "background": {
                  "disabled": "#212525"
                },
                "color": {
                  "default": "#ffffff",
                  "hover": "#ffffff",
                  "active": "#ffffff",
                  "disabled": "#515B5B",
                  "selected": "#ffffff",
                  "focusSelected": "#ffffff"
                },
                "border": {
                  "default": "#FFFFFF",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              },
              "outline": {
                "background": {
                  "default": "#212525",
                  "hover": "#394040",
                  "active": "#515B5B",
                  "disabled": "#212525",
                  "selected": "#394040",
                  "focusSelected": "#394040"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#F5F5F5",
                  "active": "#F5F5F5",
                  "disabled": "#515B5B",
                  "selected": "#FFFFFF",
                  "focusSelected": "#161A1D"
                },
                "border": {
                  "default": "#FFFFFF",
                  "hover": "#F5F5F5",
                  "active": "#EEF0F0",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              },
              "outlineSubtle": {
                "background": {
                  "default": "#151717",
                  "hover": "#394040",
                  "active": "#515B5B",
                  "disabled": "#212525",
                  "selected": "#394040",
                  "focusSelected": "#394040"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#F5F5F5",
                  "active": "#F5F5F5",
                  "disabled": "#515B5B",
                  "selected": "#FFFFFF",
                  "focusSelected": "#161A1D"
                },
                "border": {
                  "default": "#394040",
                  "hover": "#394040",
                  "focus": "#a044b9",
                  "disabled": "#212525",
                  "offset": "#151717"
                }
              },
              "subtle": {
                "background": {
                  "default": "#151717",
                  "hover": "#212525",
                  "active": "#394040",
                  "disabled": "#151717",
                  "selected": "#394040",
                  "focusSelected": "#394040"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#F5F5F5",
                  "active": "#F5F5F5",
                  "disabled": "#515B5B",
                  "selected": "#FFFFFF",
                  "focusSelected": "#161A1D"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#151717"
                }
              },
              "link": {
                "background": {
                  "default": "#151717",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#151717",
                  "selected": "#151717",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#515B5B",
                  "selected": "#EEF0F0",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#151717"
                }
              },
              "linkSubtle": {
                "background": {
                  "default": "#151717",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#151717",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#838F8F",
                  "hover": "#9EA7A7",
                  "active": "#B8C0C0",
                  "disabled": "#515B5B",
                  "selected": "#EEF0F0",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#151717"
                }
              },
              "hub": {
                "background": {
                  "disabled": "#212525"
                },
                "color": {
                  "default": "#FFFFFF",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#515B5B",
                  "selected": "#FFFFFF",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              }
            },
            "zurich": {
              "text": {
                "default": "#212121",
                "subtle": "#919191",
                "subtlest": "#E0E0E0",
                "inverse": "#EEEEEE"
              },
              "surface": {
                "default": "#C9DCE7",
                "raised": "#94BCD3"
              },
              "border": {
                "default": "#9E9E9E",
                "accent": {
                  "orange": "#FFAB40",
                  "yellow": "#EEFF41",
                  "blue": "rgb(66, 133, 244)",
                  "magenta": "#E37CAE"
                },
                "information": "#4285F4"
              },
              "background": {
                "neutral": {
                  "default": "#E2EDF3",
                  "bold": "#ACC4DC"
                },
                "information": {
                  "bold": {
                    "default": "#4285F4",
                    "hover": "#0E61EC"
                  }
                },
                "discovery": {
                  "bold": {
                    "default": "#B99AD7",
                    "hover": "#9A67CD"
                  }
                },
                "accent": {
                  "blue": "rgb(66, 133, 244)",
                  "teal": "#0097A7",
                  "orange": "#FFAB40",
                  "yellow": "#EEFF41",
                  "sky": "#C9DCE7",
                  "gray": "#212121"
                },
                "danger": {
                  "default": "#E35D5D"
                }
              },
              "icon": {
                "default": "#595959",
                "success": "#5DE36B",
                "danger": "#E35D5D"
              },
              "btn": {
                "primary": {
                  "text": "#EEEEEE",
                  "background": "#6A9FF6",
                  "activeBg": "#0E61EC",
                  "activeText": "#EEEEEE",
                  "focusRing": "#FFAB40"
                }
              }
            }
          },
          "prism": {
            "fuegokit": {
              "plainBackground": "#2C333A",
              "property": "#8BDBE5",
              "tag": "#388BFF",
              "important": "#388BFF",
              "string": "#DA62AC",
              "boolean": "#9F8FEF"
            }
          },
          "card": {
            "background": "#2C333A",
            "border": "#9FADBC",
            "heading": "#AAB4BF",
            "bodyText": "#DEE4EA",
            "buttonBg": "#579DFF",
            "buttonBgHover": "#388BFF",
            "buttonFg": "#082145"
          },
          "footerCard": {
            "background": "#2C333A"
          },
          "heading": {
            "h100": {
              "fg": "#9FADBC"
            },
            "h200": {
              "fg": "#9FADBC"
            },
            "h300": {
              "fg": "#C7D1DB"
            },
            "h400": {
              "fg": "#C7D1DB"
            },
            "h500": {
              "fg": "#C7D1DB"
            },
            "h600": {
              "fg": "#C7D1DB"
            },
            "h700": {
              "fg": "#C7D1DB"
            },
            "h800": {
              "fg": "#C7D1DB"
            },
            "h900": {
              "fg": "#C7D1DB"
            }
          },
          "surface": {
            "default": "#161A1D",
            "sunken": "#161A1D",
            "raised": "#1D2125",
            "overlay": "#22272B"
          },
          "neutral": {
            "text": "#B6C2CF",
            "default": "#a1bdd914",
            "bold": "#9FADBC"
          },
          "information": {
            "text": "#B6C2CF",
            "default": "#082145",
            "bold": "#579DFF"
          },
          "success": {
            "text": "#7EE2B8",
            "default": "#133527",
            "bold": "#4BCE97"
          },
          "warning": {
            "text": "#FFE380",
            "default": "#B38600",
            "bold": "#FFC400"
          },
          "discovery": {
            "text": "#B8ACF6",
            "default": "#231C3F",
            "bold": "#9F8FEF"
          },
          "danger": {
            "text": "#FF9C8F",
            "default": "#391813",
            "bold": "#F87462"
          }
        },
        "shadows": {
          "shadow": {
            "raised": "rgb(3 4 4 / 50%) 0px 1px 1px, rgb(3 4 4 / 50%) 0px 0px 1px;",
            "overlay": "rgba(188, 214, 240, 0.04) 0px 0px 0px, rgba(3, 4, 4, 0.36) 0px 8px 12px, rgba(3, 4, 4, 0.5) 0px 0px 1px",
            "overflow": "rgb(3 4 4 / 56%) 0px 0px 12px, rgb(3 4 4 / 50%) 0px 0px 1px"
          }
        }
      },
      "dark_high_contrast": {
        "colors": {
          "background": {
            "neutral": {
              "default": "#a1bdd914",
              "hovered": "#A6C5E229",
              "pressed": "#BFDBF847",
              "subtle": {
                "default": "#000000",
                "hovered": "#a1bdd914",
                "pressed": "#A6C5E229"
              },
              "bold": {
                "default": "#9FADBC",
                "hovered": "#B6C2CF",
                "pressed": "#C7D1DB"
              }
            },
            "accent": {
              "blue": {
                "subtlest": "#082145",
                "subtler": "#09326C",
                "subtle": "#0055CC",
                "bolder": "#579DFF"
              },
              "red": {
                "subtlest": "#391813",
                "subtler": "#601E16",
                "subtle": "#AE2A19",
                "bolder": "#F87462"
              },
              "orange": {
                "subtlest": "#43290F",
                "subtler": "#5F3811",
                "subtle": "#974F0C",
                "bolder": "#FAA53D"
              },
              "yellow": {
                "subtlest": "#B38600",
                "subtler": "#CF9F02",
                "subtle": "#FF8B00",
                "bolder": "#FFC400"
              },
              "green": {
                "subtlest": "#133527",
                "subtler": "#164B35",
                "subtle": "#216E4E",
                "bolder": "#4BCE97"
              },
              "teal": {
                "subtlest": "#153337",
                "subtler": "#1D474C",
                "subtle": "#206B74",
                "bolder": "#60C6D2"
              },
              "purple": {
                "subtlest": "#231C3F",
                "subtler": "#352C63",
                "subtle": "#5E4DB2",
                "bolder": "#9F8FEF"
              },
              "magenta": {
                "subtlest": "#341829",
                "subtler": "#50253F",
                "subtle": "#943D73",
                "bolder": "#E774BB"
              },
              "gray": {
                "subtlest": "#B6C2CF",
                "subtler": "#9FADBC",
                "subtle": "#8696A7",
                "bolder": "#2C333A"
              }
            },
            "disabled": "#a1bdd914",
            "inverse": {
              "subtle": {
                "default": "rgba(255,255,255,0.16)",
                "hovered": "rgba(255,255,255,0.24)",
                "pressed": "rgba(255,255,255,0.32)"
              }
            },
            "input": {
              "default": "#1D2125",
              "hovered": "#22272B",
              "pressed": "#1D2125"
            },
            "brand": {
              "bold": {
                "default": "#579DFF",
                "hovered": "#85B8FF",
                "pressed": "#CCE0FF"
              },
              "hovered": "#85B8FF",
              "pressed": "#CCE0FF"
            },
            "selected": {
              "default": "#082145",
              "hovered": "#09326C",
              "pressed": "#0055CC",
              "bold": {
                "default": "#579DFF",
                "hovered": "#85B8FF",
                "pressed": "#CCE0FF"
              }
            },
            "danger": {
              "default": "#391813",
              "hovered": "#601E16",
              "pressed": "#AE2A19",
              "bold": {
                "default": "#F87462",
                "hovered": "#FF9C8F",
                "pressed": "#FFD2CC"
              }
            },
            "warning": {
              "default": "#B38600",
              "hovered": "#CF9F02",
              "pressed": "#FF8B00",
              "bold": {
                "default": "#FFC400",
                "hovered": "#FFE380",
                "pressed": "#FFF0B3"
              }
            },
            "success": {
              "default": "#133527",
              "hovered": "#164B35",
              "pressed": "#216E4E",
              "bold": {
                "default": "#4BCE97",
                "hovered": "#7EE2B8",
                "pressed": "#BAF3DB"
              }
            },
            "discovery": {
              "default": "#231C3F",
              "hovered": "#352C63",
              "pressed": "#5E4DB2",
              "bold": {
                "default": "#9F8FEF",
                "hovered": "#B8ACF6",
                "pressed": "#DFD8FD"
              }
            },
            "information": {
              "default": "#082145",
              "hovered": "#09326C",
              "pressed": "#0055CC",
              "bold": {
                "default": "#579DFF",
                "hovered": "#85B8FF",
                "pressed": "#CCE0FF"
              }
            }
          },
          "blanket": {
            "default": "rgba(3,4,4,0.26)",
            "selected": "rgba(29,122,252,0.08)",
            "danger": "rgba(227,73,53,0.08)"
          },
          "skeleton": {
            "default": "#a1bdd914",
            "subtle": "#bcd6f00a"
          },
          "interaction": {
            "hovered": "rgba(0,0,0,0.16)",
            "pressed": "rgba(0,0,0,0.32)",
            "inverse": {
              "hovered": "rgba(255,255,255,0.2)",
              "pressed": "rgba(9,10,11,0.36)"
            }
          },
          "link": {
            "default": "#579DFF",
            "pressed": "#85B8FF"
          },
          "elevation": {
            "surface": {
              "default": "#161A1D",
              "sunken": "#161A1D",
              "raised": "#1D2125",
              "overlay": "#22272B"
            }
          },
          "text": {
            "default": "#B6C2CF",
            "subtle": "#9FADBC",
            "subtlest": "#8696A7",
            "disabled": "#5C6C7A",
            "inverse": "#161A1D",
            "brand": "#579DFF",
            "selected": "#579DFF",
            "danger": "#FF9C8F",
            "warning": {
              "default": "#FFE380",
              "inverse": "#161A1D"
            },
            "success": "#7EE2B8",
            "discovery": "#B8ACF6",
            "information": "#85B8FF",
            "accent": {
              "blue": {
                "default": "#85B8FF",
                "bolder": "#CCE0FF"
              },
              "red": {
                "default": "#FF9C8F",
                "bolder": "#FFD2CC"
              },
              "orange": {
                "default": "#FEC57B",
                "bolder": "#FFE2BD"
              },
              "yellow": {
                "default": "#FFE380",
                "bolder": "#FFF0B3"
              },
              "green": {
                "default": "#7EE2B8",
                "bolder": "#BAF3DB"
              },
              "purple": {
                "default": "#B8ACF6",
                "bolder": "#DFD8FD"
              },
              "teal": {
                "default": "#8BDBE5",
                "bolder": "#C1F0F5"
              },
              "magenta": {
                "default": "#F797D2",
                "bolder": "#FDD0EC"
              }
            }
          },
          "icon": {
            "default": "#9FADBC",
            "subtle": "#8696A7",
            "inverse": "#161A1D",
            "disabled": "#5C6C7A",
            "brand": "#579DFF",
            "selected": "#579DFF",
            "danger": "#EF5C48",
            "warning": {
              "default": "#E2B203",
              "inverse": "#161A1D"
            },
            "success": "#2ABB7F",
            "discovery": "#8F7EE7",
            "information": "#388BFF",
            "accent": {
              "blue": "#388BFF",
              "red": "#EF5C48",
              "orange": "#F18D13",
              "yellow": "#E2B203",
              "green": "#2ABB7F",
              "purple": "#8F7EE7",
              "teal": "#37B4C3",
              "magenta": "#DA62AC"
            }
          },
          "border": {
            "default": "#4C607D",
            "inverse": "#161A1D",
            "focused": "#85B8FF",
            "input": "#A6C5E229",
            "disabled": "#a1bdd914",
            "brand": "#579DFF",
            "selected": "#579DFF",
            "danger": "#EF5C48",
            "warning": "#E2B203",
            "success": "#2ABB7F",
            "discovery": "#8F7EE7",
            "information": "#388BFF",
            "accent": {
              "blue": "#388BFF",
              "red": "#EF5C48",
              "orange": "#F18D13",
              "yellow": "#E2B203",
              "green": "#2ABB7F",
              "purple": "#8F7EE7",
              "teal": "#37B4C3",
              "magenta": "#DA62AC"
            },
            "muted": "#2A486D",
            "subtle": "rgba(255,255,255,0.1)"
          },
          "mktg": {
            "surface": {
              "default": "#151717"
            },
            "text": {
              "default": "#FFFFFF",
              "inverse": "#151717"
            },
            "icon": {
              "default": "#FFFFFF"
            },
            "border": {
              "default": "#394040"
            },
            "btn": {
              "base": {
                "background": {
                  "default": "#6A7575",
                  "hover": "#838F8F",
                  "active": "#9EA7A7",
                  "disabled": "#212525",
                  "selected": "#9EA7A7",
                  "focusSelected": "#9EA7A7"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#F5F5F5",
                  "active": "#FFFFFF",
                  "disabled": "#515B5B",
                  "selected": "#F5F5F5",
                  "focusSelected": "#F5F5F5"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#397BFF",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              },
              "primary": {
                "background": {
                  "disabled": "#212525"
                },
                "color": {
                  "default": "#ffffff",
                  "hover": "#ffffff",
                  "active": "#ffffff",
                  "disabled": "#515B5B",
                  "selected": "#ffffff",
                  "focusSelected": "#ffffff"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              },
              "secondary": {
                "background": {
                  "disabled": "#212525"
                },
                "color": {
                  "default": "#ffffff",
                  "hover": "#ffffff",
                  "active": "#ffffff",
                  "disabled": "#515B5B",
                  "selected": "#ffffff",
                  "focusSelected": "#ffffff"
                },
                "border": {
                  "default": "#FFFFFF",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              },
              "outline": {
                "background": {
                  "default": "#212525",
                  "hover": "#394040",
                  "active": "#515B5B",
                  "disabled": "#212525",
                  "selected": "#394040",
                  "focusSelected": "#394040"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#F5F5F5",
                  "active": "#F5F5F5",
                  "disabled": "#515B5B",
                  "selected": "#FFFFFF",
                  "focusSelected": "#161A1D"
                },
                "border": {
                  "default": "#FFFFFF",
                  "hover": "#F5F5F5",
                  "active": "#EEF0F0",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              },
              "outlineSubtle": {
                "background": {
                  "default": "#151717",
                  "hover": "#394040",
                  "active": "#515B5B",
                  "disabled": "#212525",
                  "selected": "#394040",
                  "focusSelected": "#394040"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#F5F5F5",
                  "active": "#F5F5F5",
                  "disabled": "#515B5B",
                  "selected": "#FFFFFF",
                  "focusSelected": "#161A1D"
                },
                "border": {
                  "default": "#394040",
                  "hover": "#394040",
                  "focus": "#a044b9",
                  "disabled": "#212525",
                  "offset": "#151717"
                }
              },
              "subtle": {
                "background": {
                  "default": "#151717",
                  "hover": "#212525",
                  "active": "#394040",
                  "disabled": "#151717",
                  "selected": "#394040",
                  "focusSelected": "#394040"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#F5F5F5",
                  "active": "#F5F5F5",
                  "disabled": "#515B5B",
                  "selected": "#FFFFFF",
                  "focusSelected": "#161A1D"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#151717"
                }
              },
              "link": {
                "background": {
                  "default": "#151717",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#151717",
                  "selected": "#151717",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#515B5B",
                  "selected": "#EEF0F0",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#151717"
                }
              },
              "linkSubtle": {
                "background": {
                  "default": "#151717",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#151717",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#838F8F",
                  "hover": "#9EA7A7",
                  "active": "#B8C0C0",
                  "disabled": "#515B5B",
                  "selected": "#EEF0F0",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#151717"
                }
              },
              "hub": {
                "background": {
                  "disabled": "#212525"
                },
                "color": {
                  "default": "#FFFFFF",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#515B5B",
                  "selected": "#FFFFFF",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              }
            },
            "zurich": {
              "text": {
                "default": "#212121",
                "subtle": "#919191",
                "subtlest": "#E0E0E0",
                "inverse": "#EEEEEE"
              },
              "surface": {
                "default": "#C9DCE7",
                "raised": "#94BCD3"
              },
              "border": {
                "default": "#9E9E9E",
                "accent": {
                  "orange": "#FFAB40",
                  "yellow": "#EEFF41",
                  "blue": "rgb(66, 133, 244)",
                  "magenta": "#E37CAE"
                },
                "information": "#4285F4"
              },
              "background": {
                "neutral": {
                  "default": "#E2EDF3",
                  "bold": "#ACC4DC"
                },
                "information": {
                  "bold": {
                    "default": "#4285F4",
                    "hover": "#0E61EC"
                  }
                },
                "discovery": {
                  "bold": {
                    "default": "#B99AD7",
                    "hover": "#9A67CD"
                  }
                },
                "accent": {
                  "blue": "rgb(66, 133, 244)",
                  "teal": "#0097A7",
                  "orange": "#FFAB40",
                  "yellow": "#EEFF41",
                  "sky": "#C9DCE7",
                  "gray": "#212121"
                },
                "danger": {
                  "default": "#E35D5D"
                }
              },
              "icon": {
                "default": "#595959",
                "success": "#5DE36B",
                "danger": "#E35D5D"
              },
              "btn": {
                "primary": {
                  "text": "#EEEEEE",
                  "background": "#6A9FF6",
                  "activeBg": "#0E61EC",
                  "activeText": "#EEEEEE",
                  "focusRing": "#FFAB40"
                }
              }
            }
          },
          "prism": {
            "fuegokit": {
              "plainBackground": "#2C333A",
              "property": "#8BDBE5",
              "tag": "#388BFF",
              "important": "#388BFF",
              "string": "#DA62AC",
              "boolean": "#9F8FEF"
            }
          },
          "card": {
            "background": "#2C333A",
            "border": "#9FADBC",
            "heading": "#CCD1D9",
            "bodyText": "#DEE4EA",
            "buttonBg": "#579DFF",
            "buttonBgHover": "#388BFF",
            "buttonFg": "#082145"
          },
          "footerCard": {
            "background": "#2C333A"
          },
          "heading": {
            "h100": {
              "fg": "#9FADBC"
            },
            "h200": {
              "fg": "#9FADBC"
            },
            "h300": {
              "fg": "#C7D1DB"
            },
            "h400": {
              "fg": "#C7D1DB"
            },
            "h500": {
              "fg": "#C7D1DB"
            },
            "h600": {
              "fg": "#C7D1DB"
            },
            "h700": {
              "fg": "#C7D1DB"
            },
            "h800": {
              "fg": "#C7D1DB"
            },
            "h900": {
              "fg": "#C7D1DB"
            }
          },
          "surface": {
            "default": "#161A1D",
            "sunken": "#161A1D",
            "raised": "#1D2125",
            "overlay": "#22272B"
          },
          "neutral": {
            "text": "#B6C2CF",
            "default": "#a1bdd914",
            "bold": "#9FADBC"
          },
          "information": {
            "text": "#B6C2CF",
            "default": "#082145",
            "bold": "#579DFF"
          },
          "success": {
            "text": "#7EE2B8",
            "default": "#133527",
            "bold": "#4BCE97"
          },
          "warning": {
            "text": "#FFE380",
            "default": "#B38600",
            "bold": "#FFC400"
          },
          "discovery": {
            "text": "#B8ACF6",
            "default": "#231C3F",
            "bold": "#9F8FEF"
          },
          "danger": {
            "text": "#FF9C8F",
            "default": "#391813",
            "bold": "#F87462"
          }
        },
        "shadows": {
          "shadow": {
            "raised": "rgb(3 4 4 / 50%) 0px 1px 1px, rgb(3 4 4 / 50%) 0px 0px 1px;",
            "overlay": "rgba(188, 214, 240, 0.04) 0px 0px 0px, rgba(3, 4, 4, 0.36) 0px 8px 12px, rgba(3, 4, 4, 0.5) 0px 0px 1px",
            "overflow": "rgb(3 4 4 / 56%) 0px 0px 12px, rgb(3 4 4 / 50%) 0px 0px 1px"
          }
        }
      },
      "dark_colorblind": {
        "colors": {
          "background": {
            "neutral": {
              "default": "#a1bdd914",
              "hovered": "#A6C5E229",
              "pressed": "#BFDBF847",
              "subtle": {
                "default": "#000000",
                "hovered": "#a1bdd914",
                "pressed": "#A6C5E229"
              },
              "bold": {
                "default": "#9FADBC",
                "hovered": "#B6C2CF",
                "pressed": "#C7D1DB"
              }
            },
            "accent": {
              "blue": {
                "subtlest": "#082145",
                "subtler": "#09326C",
                "subtle": "#0055CC",
                "bolder": "#579DFF"
              },
              "red": {
                "subtlest": "#391813",
                "subtler": "#601E16",
                "subtle": "#AE2A19",
                "bolder": "#F87462"
              },
              "orange": {
                "subtlest": "#43290F",
                "subtler": "#5F3811",
                "subtle": "#974F0C",
                "bolder": "#FAA53D"
              },
              "yellow": {
                "subtlest": "#B38600",
                "subtler": "#CF9F02",
                "subtle": "#FF8B00",
                "bolder": "#FFC400"
              },
              "green": {
                "subtlest": "#133527",
                "subtler": "#164B35",
                "subtle": "#216E4E",
                "bolder": "#4BCE97"
              },
              "teal": {
                "subtlest": "#153337",
                "subtler": "#1D474C",
                "subtle": "#206B74",
                "bolder": "#60C6D2"
              },
              "purple": {
                "subtlest": "#231C3F",
                "subtler": "#352C63",
                "subtle": "#5E4DB2",
                "bolder": "#9F8FEF"
              },
              "magenta": {
                "subtlest": "#341829",
                "subtler": "#50253F",
                "subtle": "#943D73",
                "bolder": "#E774BB"
              },
              "gray": {
                "subtlest": "#B6C2CF",
                "subtler": "#9FADBC",
                "subtle": "#8696A7",
                "bolder": "#2C333A"
              }
            },
            "disabled": "#a1bdd914",
            "inverse": {
              "subtle": {
                "default": "rgba(255,255,255,0.16)",
                "hovered": "rgba(255,255,255,0.24)",
                "pressed": "rgba(255,255,255,0.32)"
              }
            },
            "input": {
              "default": "#1D2125",
              "hovered": "#22272B",
              "pressed": "#1D2125"
            },
            "brand": {
              "bold": {
                "default": "#579DFF",
                "hovered": "#85B8FF",
                "pressed": "#CCE0FF"
              },
              "hovered": "#85B8FF",
              "pressed": "#CCE0FF"
            },
            "selected": {
              "default": "#082145",
              "hovered": "#09326C",
              "pressed": "#0055CC",
              "bold": {
                "default": "#579DFF",
                "hovered": "#85B8FF",
                "pressed": "#CCE0FF"
              }
            },
            "danger": {
              "default": "#391813",
              "hovered": "#601E16",
              "pressed": "#AE2A19",
              "bold": {
                "default": "#F87462",
                "hovered": "#FF9C8F",
                "pressed": "#FFD2CC"
              }
            },
            "warning": {
              "default": "#B38600",
              "hovered": "#CF9F02",
              "pressed": "#FF8B00",
              "bold": {
                "default": "#FFC400",
                "hovered": "#FFE380",
                "pressed": "#FFF0B3"
              }
            },
            "success": {
              "default": "#133527",
              "hovered": "#164B35",
              "pressed": "#216E4E",
              "bold": {
                "default": "#4BCE97",
                "hovered": "#7EE2B8",
                "pressed": "#BAF3DB"
              }
            },
            "discovery": {
              "default": "#231C3F",
              "hovered": "#352C63",
              "pressed": "#5E4DB2",
              "bold": {
                "default": "#9F8FEF",
                "hovered": "#B8ACF6",
                "pressed": "#DFD8FD"
              }
            },
            "information": {
              "default": "#082145",
              "hovered": "#09326C",
              "pressed": "#0055CC",
              "bold": {
                "default": "#579DFF",
                "hovered": "#85B8FF",
                "pressed": "#CCE0FF"
              }
            }
          },
          "blanket": {
            "default": "rgba(3,4,4,0.26)",
            "selected": "rgba(29,122,252,0.08)",
            "danger": "rgba(227,73,53,0.08)"
          },
          "skeleton": {
            "default": "#a1bdd914",
            "subtle": "#bcd6f00a"
          },
          "interaction": {
            "hovered": "rgba(0,0,0,0.16)",
            "pressed": "rgba(0,0,0,0.32)",
            "inverse": {
              "hovered": "rgba(255,255,255,0.2)",
              "pressed": "rgba(9,10,11,0.36)"
            }
          },
          "link": {
            "default": "#579DFF",
            "pressed": "#85B8FF"
          },
          "elevation": {
            "surface": {
              "default": "#161A1D",
              "sunken": "#161A1D",
              "raised": "#1D2125",
              "overlay": "#22272B"
            }
          },
          "text": {
            "default": "#B6C2CF",
            "subtle": "#9FADBC",
            "subtlest": "#8696A7",
            "disabled": "#5C6C7A",
            "inverse": "#161A1D",
            "brand": "#579DFF",
            "selected": "#579DFF",
            "danger": "#FF9C8F",
            "warning": {
              "default": "#FFE380",
              "inverse": "#161A1D"
            },
            "success": "#7EE2B8",
            "discovery": "#B8ACF6",
            "information": "#85B8FF",
            "accent": {
              "blue": {
                "default": "#85B8FF",
                "bolder": "#CCE0FF"
              },
              "red": {
                "default": "#FF9C8F",
                "bolder": "#FFD2CC"
              },
              "orange": {
                "default": "#FEC57B",
                "bolder": "#FFE2BD"
              },
              "yellow": {
                "default": "#FFE380",
                "bolder": "#FFF0B3"
              },
              "green": {
                "default": "#7EE2B8",
                "bolder": "#BAF3DB"
              },
              "purple": {
                "default": "#B8ACF6",
                "bolder": "#DFD8FD"
              },
              "teal": {
                "default": "#8BDBE5",
                "bolder": "#C1F0F5"
              },
              "magenta": {
                "default": "#F797D2",
                "bolder": "#FDD0EC"
              }
            }
          },
          "icon": {
            "default": "#9FADBC",
            "subtle": "#8696A7",
            "inverse": "#161A1D",
            "disabled": "#5C6C7A",
            "brand": "#579DFF",
            "selected": "#579DFF",
            "danger": "#EF5C48",
            "warning": {
              "default": "#E2B203",
              "inverse": "#161A1D"
            },
            "success": "#2ABB7F",
            "discovery": "#8F7EE7",
            "information": "#388BFF",
            "accent": {
              "blue": "#388BFF",
              "red": "#EF5C48",
              "orange": "#F18D13",
              "yellow": "#E2B203",
              "green": "#2ABB7F",
              "purple": "#8F7EE7",
              "teal": "#37B4C3",
              "magenta": "#DA62AC"
            }
          },
          "border": {
            "default": "#57606a",
            "inverse": "#161A1D",
            "focused": "#85B8FF",
            "input": "#A6C5E229",
            "disabled": "#a1bdd914",
            "brand": "#579DFF",
            "selected": "#579DFF",
            "danger": "#EF5C48",
            "warning": "#E2B203",
            "success": "#2ABB7F",
            "discovery": "#8F7EE7",
            "information": "#388BFF",
            "accent": {
              "blue": "#388BFF",
              "red": "#EF5C48",
              "orange": "#F18D13",
              "yellow": "#E2B203",
              "green": "#2ABB7F",
              "purple": "#8F7EE7",
              "teal": "#37B4C3",
              "magenta": "#DA62AC"
            },
            "muted": "#424a53",
            "subtle": "rgba(244,245,247,0.1)"
          },
          "mktg": {
            "surface": {
              "default": "#151717"
            },
            "text": {
              "default": "#FFFFFF",
              "inverse": "#151717"
            },
            "icon": {
              "default": "#FFFFFF"
            },
            "border": {
              "default": "#394040"
            },
            "btn": {
              "base": {
                "background": {
                  "default": "#6A7575",
                  "hover": "#838F8F",
                  "active": "#9EA7A7",
                  "disabled": "#212525",
                  "selected": "#9EA7A7",
                  "focusSelected": "#9EA7A7"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#F5F5F5",
                  "active": "#FFFFFF",
                  "disabled": "#515B5B",
                  "selected": "#F5F5F5",
                  "focusSelected": "#F5F5F5"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#397BFF",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              },
              "primary": {
                "background": {
                  "disabled": "#212525"
                },
                "color": {
                  "default": "#ffffff",
                  "hover": "#ffffff",
                  "active": "#ffffff",
                  "disabled": "#515B5B",
                  "selected": "#ffffff",
                  "focusSelected": "#ffffff"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              },
              "secondary": {
                "background": {
                  "disabled": "#212525"
                },
                "color": {
                  "default": "#ffffff",
                  "hover": "#ffffff",
                  "active": "#ffffff",
                  "disabled": "#515B5B",
                  "selected": "#ffffff",
                  "focusSelected": "#ffffff"
                },
                "border": {
                  "default": "#FFFFFF",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              },
              "outline": {
                "background": {
                  "default": "#212525",
                  "hover": "#394040",
                  "active": "#515B5B",
                  "disabled": "#212525",
                  "selected": "#394040",
                  "focusSelected": "#394040"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#F5F5F5",
                  "active": "#F5F5F5",
                  "disabled": "#515B5B",
                  "selected": "#FFFFFF",
                  "focusSelected": "#161A1D"
                },
                "border": {
                  "default": "#FFFFFF",
                  "hover": "#F5F5F5",
                  "active": "#EEF0F0",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              },
              "outlineSubtle": {
                "background": {
                  "default": "#151717",
                  "hover": "#394040",
                  "active": "#515B5B",
                  "disabled": "#212525",
                  "selected": "#394040",
                  "focusSelected": "#394040"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#F5F5F5",
                  "active": "#F5F5F5",
                  "disabled": "#515B5B",
                  "selected": "#FFFFFF",
                  "focusSelected": "#161A1D"
                },
                "border": {
                  "default": "#394040",
                  "hover": "#394040",
                  "focus": "#a044b9",
                  "disabled": "#212525",
                  "offset": "#151717"
                }
              },
              "subtle": {
                "background": {
                  "default": "#151717",
                  "hover": "#212525",
                  "active": "#394040",
                  "disabled": "#151717",
                  "selected": "#394040",
                  "focusSelected": "#394040"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#F5F5F5",
                  "active": "#F5F5F5",
                  "disabled": "#515B5B",
                  "selected": "#FFFFFF",
                  "focusSelected": "#161A1D"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#151717"
                }
              },
              "link": {
                "background": {
                  "default": "#151717",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#151717",
                  "selected": "#151717",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#F5F5F5",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#515B5B",
                  "selected": "#EEF0F0",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#151717"
                }
              },
              "linkSubtle": {
                "background": {
                  "default": "#151717",
                  "hover": "#151717",
                  "active": "#151717",
                  "disabled": "#151717",
                  "selected": "#D3D8D8",
                  "focusSelected": "#D3D8D8"
                },
                "color": {
                  "default": "#838F8F",
                  "hover": "#9EA7A7",
                  "active": "#B8C0C0",
                  "disabled": "#515B5B",
                  "selected": "#EEF0F0",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "hover": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#151717"
                }
              },
              "hub": {
                "background": {
                  "disabled": "#212525"
                },
                "color": {
                  "default": "#FFFFFF",
                  "hover": "#FFFFFF",
                  "active": "#FFFFFF",
                  "disabled": "#515B5B",
                  "selected": "#FFFFFF",
                  "focusSelected": "#FFFFFF"
                },
                "border": {
                  "default": "rgba(0,0,0,0)",
                  "focus": "#a044b9",
                  "offset": "#151717",
                  "disabled": "#212525"
                }
              }
            },
            "zurich": {
              "text": {
                "default": "#212121",
                "subtle": "#919191",
                "subtlest": "#E0E0E0",
                "inverse": "#EEEEEE"
              },
              "surface": {
                "default": "#C9DCE7",
                "raised": "#94BCD3"
              },
              "border": {
                "default": "#9E9E9E",
                "accent": {
                  "orange": "#FFAB40",
                  "yellow": "#EEFF41",
                  "blue": "rgb(66, 133, 244)",
                  "magenta": "#E37CAE"
                },
                "information": "#4285F4"
              },
              "background": {
                "neutral": {
                  "default": "#E2EDF3",
                  "bold": "#ACC4DC"
                },
                "information": {
                  "bold": {
                    "default": "#4285F4",
                    "hover": "#0E61EC"
                  }
                },
                "discovery": {
                  "bold": {
                    "default": "#B99AD7",
                    "hover": "#9A67CD"
                  }
                },
                "accent": {
                  "blue": "rgb(66, 133, 244)",
                  "teal": "#0097A7",
                  "orange": "#FFAB40",
                  "yellow": "#EEFF41",
                  "sky": "#C9DCE7",
                  "gray": "#212121"
                },
                "danger": {
                  "default": "#E35D5D"
                }
              },
              "icon": {
                "default": "#595959",
                "success": "#5DE36B",
                "danger": "#E35D5D"
              },
              "btn": {
                "primary": {
                  "text": "#EEEEEE",
                  "background": "#6A9FF6",
                  "activeBg": "#0E61EC",
                  "activeText": "#EEEEEE",
                  "focusRing": "#FFAB40"
                }
              }
            }
          },
          "prism": {
            "fuegokit": {
              "plainBackground": "#2C333A",
              "property": "#8BDBE5",
              "tag": "#388BFF",
              "important": "#388BFF",
              "string": "#DA62AC",
              "boolean": "#9F8FEF"
            }
          },
          "card": {
            "background": "#2C333A",
            "border": "#9FADBC",
            "heading": "#DFE1E6",
            "bodyText": "#DEE4EA",
            "buttonBg": "#579DFF",
            "buttonBgHover": "#388BFF",
            "buttonFg": "#082145"
          },
          "footerCard": {
            "background": "#2C333A"
          },
          "heading": {
            "h100": {
              "fg": "#9FADBC"
            },
            "h200": {
              "fg": "#9FADBC"
            },
            "h300": {
              "fg": "#C7D1DB"
            },
            "h400": {
              "fg": "#C7D1DB"
            },
            "h500": {
              "fg": "#C7D1DB"
            },
            "h600": {
              "fg": "#C7D1DB"
            },
            "h700": {
              "fg": "#C7D1DB"
            },
            "h800": {
              "fg": "#C7D1DB"
            },
            "h900": {
              "fg": "#C7D1DB"
            }
          },
          "surface": {
            "default": "#161A1D",
            "sunken": "#161A1D",
            "raised": "#1D2125",
            "overlay": "#22272B"
          },
          "neutral": {
            "text": "#B6C2CF",
            "default": "#a1bdd914",
            "bold": "#9FADBC"
          },
          "information": {
            "text": "#B6C2CF",
            "default": "#082145",
            "bold": "#579DFF"
          },
          "success": {
            "text": "#7EE2B8",
            "default": "#133527",
            "bold": "#4BCE97"
          },
          "warning": {
            "text": "#FFE380",
            "default": "#B38600",
            "bold": "#FFC400"
          },
          "discovery": {
            "text": "#B8ACF6",
            "default": "#231C3F",
            "bold": "#9F8FEF"
          },
          "danger": {
            "text": "#FF9C8F",
            "default": "#391813",
            "bold": "#F87462"
          }
        },
        "shadows": {
          "shadow": {
            "raised": "rgb(3 4 4 / 50%) 0px 1px 1px, rgb(3 4 4 / 50%) 0px 0px 1px;",
            "overlay": "rgba(188, 214, 240, 0.04) 0px 0px 0px, rgba(3, 4, 4, 0.36) 0px 8px 12px, rgba(3, 4, 4, 0.5) 0px 0px 1px",
            "overflow": "rgb(3 4 4 / 56%) 0px 0px 12px, rgb(3 4 4 / 50%) 0px 0px 1px"
          }
        }
      }
    }
  }
};